/**
 * ⚠️ ARQUIVO AUTO-GERADO.
 * Não edite manualmente.
 * Execute o script 'npm run sync:enums' no apps/back.
 */
export var AbrangenciaNivelEnum;
(function (AbrangenciaNivelEnum) {
    AbrangenciaNivelEnum[AbrangenciaNivelEnum["ALTA"] = 1] = "ALTA";
    AbrangenciaNivelEnum[AbrangenciaNivelEnum["MEDIA"] = 2] = "MEDIA";
    AbrangenciaNivelEnum[AbrangenciaNivelEnum["BAIXA"] = 3] = "BAIXA";
})(AbrangenciaNivelEnum || (AbrangenciaNivelEnum = {}));
export var AntecipacaoCategoria;
(function (AntecipacaoCategoria) {
    AntecipacaoCategoria["ESPACO"] = "ESPACO";
    AntecipacaoCategoria["AEB"] = "AEB";
    AntecipacaoCategoria["ARTISTICO"] = "ARTISTICO";
    AntecipacaoCategoria["LOGISTICA"] = "LOGISTICA";
    AntecipacaoCategoria["MATERIAL_GRAFICO"] = "MATERIAL_GRAFICO";
    AntecipacaoCategoria["CENOGRAFIA"] = "CENOGRAFIA";
    AntecipacaoCategoria["TECNICA"] = "TECNICA";
    AntecipacaoCategoria["TECNOLOGIA"] = "TECNOLOGIA";
    AntecipacaoCategoria["SERVICOS"] = "SERVICOS";
    AntecipacaoCategoria["OUTROS"] = "OUTROS";
})(AntecipacaoCategoria || (AntecipacaoCategoria = {}));
export var ApStatus;
(function (ApStatus) {
    ApStatus["AGUARDANDO_APROVACAO"] = "";
    ApStatus["AGUARDANDO_APROVACAO_CLIENTE"] = "*";
    ApStatus["APROVADO"] = "A";
    ApStatus["APROVADO_NAO_FATURAR"] = "P";
    ApStatus["NAO_APROVADO"] = "N";
    ApStatus["SUSPENSO"] = "S";
    ApStatus["LIBERADO_FATURAMENTO"] = "L";
    ApStatus["FATURADO"] = "F";
    ApStatus["CANCELADO"] = "C";
    ApStatus["FECHADO"] = "O";
    ApStatus["REVISADO"] = "R";
    ApStatus["RECUSADO"] = "D";
})(ApStatus || (ApStatus = {}));
export var ApprovalScope;
(function (ApprovalScope) {
    ApprovalScope["OWN_ROLE"] = "OWN_ROLE";
    ApprovalScope["WHOLE_STAGE"] = "WHOLE_STAGE";
})(ApprovalScope || (ApprovalScope = {}));
export var EtapaStatus;
(function (EtapaStatus) {
    EtapaStatus["EM_REVISAO"] = "EM_REVISAO";
    EtapaStatus["APROVADO"] = "APROVADO";
    EtapaStatus["REJEITADO"] = "REJEITADO";
})(EtapaStatus || (EtapaStatus = {}));
export var EtapaAprovacaoStatus;
(function (EtapaAprovacaoStatus) {
    EtapaAprovacaoStatus["PENDENTE"] = "PENDENTE";
    EtapaAprovacaoStatus["AGUARDANDO"] = "AGUARDANDO";
    EtapaAprovacaoStatus["APROVADO"] = "APROVADO";
    EtapaAprovacaoStatus["REPROVADO"] = "REPROVADO";
    EtapaAprovacaoStatus["ABORTADO"] = "ABORTADO";
    EtapaAprovacaoStatus["CANCELADO"] = "CANCELADO";
    EtapaAprovacaoStatus["AUSENTE"] = "AUSENTE";
    EtapaAprovacaoStatus["DESAPROVADO"] = "DESAPROVADO";
})(EtapaAprovacaoStatus || (EtapaAprovacaoStatus = {}));
export var AreaEnum;
(function (AreaEnum) {
    AreaEnum["ATENDIMENTO"] = "ATENDIMENTO";
    AreaEnum["TECNOLOGIA"] = "TECNOLOGIA";
    AreaEnum["PRE_PRODUCAO"] = "PRE_PRODUCAO";
    AreaEnum["COMPRAS"] = "COMPRAS";
    AreaEnum["CRIACAO"] = "CRIACAO";
    AreaEnum["PLANEJAMENTO"] = "PLANEJAMENTO";
    AreaEnum["PRODUCAO_FINANCEIRA"] = "PRODUCAO_FINANCEIRA";
    AreaEnum["FINANCEIRO"] = "FINANCEIRO";
    AreaEnum["CONTROLADORIA"] = "CONTROLADORIA";
    AreaEnum["PRODUCAO"] = "PRODUCAO";
    AreaEnum["PRODUCAO_GRAFICA"] = "PRODUCAO_GRAFICA";
})(AreaEnum || (AreaEnum = {}));
export var ArquivoLogAcao;
(function (ArquivoLogAcao) {
    ArquivoLogAcao["UPLOAD"] = "UPLOAD";
    ArquivoLogAcao["DOWNLOAD"] = "DOWNLOAD";
    ArquivoLogAcao["DELETE"] = "DELETE";
    ArquivoLogAcao["REPLACE"] = "REPLACE";
    ArquivoLogAcao["GET_URL"] = "GET_URL";
})(ArquivoLogAcao || (ArquivoLogAcao = {}));
export var TipoArquivo;
(function (TipoArquivo) {
    TipoArquivo["INTERNO"] = "INTERNO";
    TipoArquivo["COMERCIAL"] = "COMERCIAL";
    TipoArquivo["APROVACAO"] = "APROVACAO";
    TipoArquivo["JOB_BRIEFING"] = "JOB_BRIEFING";
    TipoArquivo["JOB_PAPER"] = "JOB_PAPER";
    TipoArquivo["JOB_ESTUDO_VERBA"] = "JOB_ESTUDO_VERBA";
    TipoArquivo["JOB_PROJETO_EXECUTIVO"] = "JOB_PROJETO_EXECUTIVO";
    TipoArquivo["JOB_PROJETO_FINAL"] = "JOB_PROJETO_FINAL";
    TipoArquivo["COMPRAS"] = "COMPRAS";
    TipoArquivo["AP"] = "AP";
    TipoArquivo["PO"] = "PO";
    TipoArquivo["NF"] = "NF";
    TipoArquivo["JOB_PLANEJAMENTO_APRESENTACAO"] = "JOB_PLANEJAMENTO_APRESENTACAO";
    TipoArquivo["COMPROVANTE_ENTREGA_FATURAMENTO"] = "COMPROVANTE_ENTREGA_FATURAMENTO";
    TipoArquivo["TAREFA"] = "TAREFA";
    TipoArquivo["EVIDENCIA_BRINDE"] = "EVIDENCIA_BRINDE";
})(TipoArquivo || (TipoArquivo = {}));
export var AtendimentoLogEvento;
(function (AtendimentoLogEvento) {
    AtendimentoLogEvento["ALTERADO"] = "ALTERADO";
    AtendimentoLogEvento["FEELING_ALTERADO"] = "FEELING_ALTERADO";
    AtendimentoLogEvento["INATIVADO"] = "INATIVADO";
})(AtendimentoLogEvento || (AtendimentoLogEvento = {}));
export var ClienteSegmento;
(function (ClienteSegmento) {
    ClienteSegmento["ALIMENTOS_BEBIDAS"] = "ALIMENTOS_BEBIDAS";
    ClienteSegmento["VAREJO"] = "VAREJO";
    ClienteSegmento["SAUDE_BELEZA"] = "SAUDE_BELEZA";
    ClienteSegmento["TECNOLOGIA"] = "TECNOLOGIA";
    ClienteSegmento["AUTOMOTIVO"] = "AUTOMOTIVO";
    ClienteSegmento["SERVICOS_FINANCEIROS"] = "SERVICOS_FINANCEIROS";
    ClienteSegmento["OUTROS"] = "OUTROS";
})(ClienteSegmento || (ClienteSegmento = {}));
export var CompraStatus;
(function (CompraStatus) {
    CompraStatus["SEM_OPORTUNIDADE"] = "SEM_OPORTUNIDADE";
    CompraStatus["EM_NEGOCIACAO"] = "EM_NEGOCIACAO";
    CompraStatus["NEGOCIADO"] = "NEGOCIADO";
})(CompraStatus || (CompraStatus = {}));
export var ComunicadoSistemaAlvoTipo;
(function (ComunicadoSistemaAlvoTipo) {
    ComunicadoSistemaAlvoTipo["CARGO"] = "CARGO";
    ComunicadoSistemaAlvoTipo["AREA"] = "AREA";
})(ComunicadoSistemaAlvoTipo || (ComunicadoSistemaAlvoTipo = {}));
export var ComunicadoSistemaNivel;
(function (ComunicadoSistemaNivel) {
    ComunicadoSistemaNivel["INFORMATIVO"] = "INFORMATIVO";
    ComunicadoSistemaNivel["ALERTA"] = "ALERTA";
    ComunicadoSistemaNivel["CRITICO"] = "CRITICO";
})(ComunicadoSistemaNivel || (ComunicadoSistemaNivel = {}));
export var ComunicadoSistemaStatus;
(function (ComunicadoSistemaStatus) {
    ComunicadoSistemaStatus["RASCUNHO"] = "RASCUNHO";
    ComunicadoSistemaStatus["PUBLICADO"] = "PUBLICADO";
    ComunicadoSistemaStatus["ARQUIVADO"] = "ARQUIVADO";
})(ComunicadoSistemaStatus || (ComunicadoSistemaStatus = {}));
export var ConciliacaoApsRentabilidadeStatus;
(function (ConciliacaoApsRentabilidadeStatus) {
    ConciliacaoApsRentabilidadeStatus["PENDENTE"] = "PENDENTE";
    ConciliacaoApsRentabilidadeStatus["RESOLVIDO"] = "RESOLVIDO";
    ConciliacaoApsRentabilidadeStatus["DESCONTINUADA"] = "DESCONTINUADA";
})(ConciliacaoApsRentabilidadeStatus || (ConciliacaoApsRentabilidadeStatus = {}));
export var ContatoLogCategoria;
(function (ContatoLogCategoria) {
    ContatoLogCategoria["ALTERACAO"] = "ALTERACAO";
    ContatoLogCategoria["ACESSO"] = "ACESSO";
})(ContatoLogCategoria || (ContatoLogCategoria = {}));
export var ContatoLogEvento;
(function (ContatoLogEvento) {
    ContatoLogEvento["CRIADO"] = "CRIADO";
    ContatoLogEvento["ALTERADO"] = "ALTERADO";
    ContatoLogEvento["SECAO_CONFIRMADA"] = "SECAO_CONFIRMADA";
    ContatoLogEvento["MUDOU_DE_EMPRESA"] = "MUDOU_DE_EMPRESA";
    ContatoLogEvento["CLIENTE_CORRIGIDO"] = "CLIENTE_CORRIGIDO";
    ContatoLogEvento["CARGO_ALTERADO"] = "CARGO_ALTERADO";
    ContatoLogEvento["RESPONSAVEL_ALTERADO"] = "RESPONSAVEL_ALTERADO";
    ContatoLogEvento["RESPONSAVEIS_ALTERADOS"] = "RESPONSAVEIS_ALTERADOS";
    ContatoLogEvento["NAO_CONTATAR_MARCADO"] = "NAO_CONTATAR_MARCADO";
    ContatoLogEvento["NAO_CONTATAR_DESMARCADO"] = "NAO_CONTATAR_DESMARCADO";
    ContatoLogEvento["INATIVADO"] = "INATIVADO";
    ContatoLogEvento["REATIVADO"] = "REATIVADO";
    ContatoLogEvento["ANONIMIZADO"] = "ANONIMIZADO";
    ContatoLogEvento["DADO_REVELADO"] = "DADO_REVELADO";
    ContatoLogEvento["DADO_EXPORTADO"] = "DADO_EXPORTADO";
    ContatoLogEvento["ABSORVEU"] = "ABSORVEU";
    ContatoLogEvento["MESCLADO"] = "MESCLADO";
})(ContatoLogEvento || (ContatoLogEvento = {}));
export var ContatoStatus;
(function (ContatoStatus) {
    ContatoStatus["ATIVO"] = "ATIVO";
    ContatoStatus["INATIVO"] = "INATIVO";
    ContatoStatus["ANONIMIZADO"] = "ANONIMIZADO";
    ContatoStatus["MESCLADO"] = "MESCLADO";
})(ContatoStatus || (ContatoStatus = {}));
export var ContatoTipo;
(function (ContatoTipo) {
    ContatoTipo["CLIENTE"] = "CLIENTE";
    ContatoTipo["FORNECEDOR"] = "FORNECEDOR";
    ContatoTipo["PARCEIRO"] = "PARCEIRO";
})(ContatoTipo || (ContatoTipo = {}));
export var ContatoNivel;
(function (ContatoNivel) {
    // A ordem é a da tela: I, II, III (o Normal é o padrão).
    ContatoNivel["ESTRATEGICO"] = "ESTRATEGICO";
    ContatoNivel["IMPORTANTE"] = "IMPORTANTE";
    ContatoNivel["NORMAL"] = "NORMAL";
})(ContatoNivel || (ContatoNivel = {}));
export var ContatoDataComemorativa;
(function (ContatoDataComemorativa) {
    ContatoDataComemorativa["ANIVERSARIO"] = "ANIVERSARIO";
    ContatoDataComemorativa["DIA_DAS_CRIANCAS"] = "DIA_DAS_CRIANCAS";
    ContatoDataComemorativa["DIA_DAS_MAES"] = "DIA_DAS_MAES";
    ContatoDataComemorativa["DIA_DOS_PAIS"] = "DIA_DOS_PAIS";
})(ContatoDataComemorativa || (ContatoDataComemorativa = {}));
export var ContatoSecao;
(function (ContatoSecao) {
    ContatoSecao["ENDERECO"] = "ENDERECO";
    ContatoSecao["TELEFONE_PESSOAL"] = "TELEFONE_PESSOAL";
    ContatoSecao["TELEFONE_CORPORATIVO"] = "TELEFONE_CORPORATIVO";
    ContatoSecao["EMAIL"] = "EMAIL";
    ContatoSecao["PERFIL"] = "PERFIL";
})(ContatoSecao || (ContatoSecao = {}));
export var ContatoDadoSituacao;
(function (ContatoDadoSituacao) {
    ContatoDadoSituacao["EM_DIA"] = "EM_DIA";
    ContatoDadoSituacao["PODE_ESTAR_DESATUALIZADO"] = "PODE_ESTAR_DESATUALIZADO";
})(ContatoDadoSituacao || (ContatoDadoSituacao = {}));
export var ContatoSensibilidade;
(function (ContatoSensibilidade) {
    ContatoSensibilidade["COMUM"] = "COMUM";
    ContatoSensibilidade["PROFISSIONAL"] = "PROFISSIONAL";
    ContatoSensibilidade["PESSOAL"] = "PESSOAL";
})(ContatoSensibilidade || (ContatoSensibilidade = {}));
export var CreditavelTipo;
(function (CreditavelTipo) {
    CreditavelTipo["CREDITO"] = "CREDITO";
})(CreditavelTipo || (CreditavelTipo = {}));
export var CentroCustoCor;
(function (CentroCustoCor) {
    CentroCustoCor["AZUL"] = "AZUL";
    CentroCustoCor["VERDE"] = "VERDE";
    CentroCustoCor["ROXO"] = "ROXO";
    CentroCustoCor["AMBAR"] = "AMBAR";
    CentroCustoCor["ROSA"] = "ROSA";
    CentroCustoCor["TEAL"] = "TEAL";
    CentroCustoCor["CINZA"] = "CINZA";
    CentroCustoCor["VERMELHO"] = "VERMELHO";
    CentroCustoCor["LARANJA"] = "LARANJA";
    CentroCustoCor["INDIGO"] = "INDIGO";
    CentroCustoCor["LIMA"] = "LIMA";
    CentroCustoCor["MARROM"] = "MARROM";
})(CentroCustoCor || (CentroCustoCor = {}));
export var CentroCustoIcone;
(function (CentroCustoIcone) {
    CentroCustoIcone["SERVER"] = "server";
    CentroCustoIcone["DESKTOP"] = "device-desktop";
    CentroCustoIcone["CART"] = "shopping-cart";
    CentroCustoIcone["BUILDING"] = "building";
    CentroCustoIcone["USERS"] = "users";
    CentroCustoIcone["BULB"] = "bulb";
    CentroCustoIcone["WORLD"] = "world";
    CentroCustoIcone["INVOICE"] = "file-invoice";
    CentroCustoIcone["CARD"] = "credit-card";
    CentroCustoIcone["BRIEFCASE"] = "briefcase";
    CentroCustoIcone["CPU"] = "cpu";
    CentroCustoIcone["CLOUD"] = "cloud";
})(CentroCustoIcone || (CentroCustoIcone = {}));
export var Periodicidade;
(function (Periodicidade) {
    Periodicidade["MENSAL"] = "MENSAL";
    Periodicidade["TRIMESTRAL"] = "TRIMESTRAL";
    Periodicidade["SEMESTRAL"] = "SEMESTRAL";
    Periodicidade["ANUAL"] = "ANUAL";
})(Periodicidade || (Periodicidade = {}));
export var CustoRecorrenteStatus;
(function (CustoRecorrenteStatus) {
    CustoRecorrenteStatus["ATIVO"] = "ATIVO";
    CustoRecorrenteStatus["CANCELADO"] = "CANCELADO";
})(CustoRecorrenteStatus || (CustoRecorrenteStatus = {}));
export var CustoRealizadoStatus;
(function (CustoRealizadoStatus) {
    CustoRealizadoStatus["PREVISTO"] = "PREVISTO";
    CustoRealizadoStatus["PAGO"] = "PAGO";
    CustoRealizadoStatus["ATRASADO"] = "ATRASADO";
    CustoRealizadoStatus["PARCIAL"] = "PARCIAL";
    CustoRealizadoStatus["NAO_CLASSIFICADO"] = "NAO_CLASSIFICADO";
    CustoRealizadoStatus["CONTESTADO"] = "CONTESTADO";
    CustoRealizadoStatus["REMOVIDO"] = "REMOVIDO";
    CustoRealizadoStatus["CANCELADO"] = "CANCELADO";
})(CustoRealizadoStatus || (CustoRealizadoStatus = {}));
export var CustoResponsavelNivel;
(function (CustoResponsavelNivel) {
    CustoResponsavelNivel["LEITURA"] = "LEITURA";
    CustoResponsavelNivel["EDICAO"] = "EDICAO";
})(CustoResponsavelNivel || (CustoResponsavelNivel = {}));
export var CustoBudgetVersaoStatus;
(function (CustoBudgetVersaoStatus) {
    CustoBudgetVersaoStatus["RASCUNHO"] = "RASCUNHO";
    CustoBudgetVersaoStatus["EM_APROVACAO"] = "EM_APROVACAO";
    CustoBudgetVersaoStatus["APROVADO"] = "APROVADO";
    CustoBudgetVersaoStatus["REPROVADO"] = "REPROVADO";
})(CustoBudgetVersaoStatus || (CustoBudgetVersaoStatus = {}));
export var CustoFechamentoStatus;
(function (CustoFechamentoStatus) {
    CustoFechamentoStatus["ABERTO"] = "ABERTO";
    /**
    * O mês acabou (§3.6.3). Não é "alguém aprovou": quem fecha é o próprio responsável pela
    * área, e o que congela é o mês estar **concluído**. O escape é reabrir com motivo.
    */
    CustoFechamentoStatus["FECHADO"] = "FECHADO";
})(CustoFechamentoStatus || (CustoFechamentoStatus = {}));
export var TipoOperacaoLinhaFechamento;
(function (TipoOperacaoLinhaFechamento) {
    TipoOperacaoLinhaFechamento["AJUSTAR_ESPERADO"] = "AJUSTAR_ESPERADO";
    TipoOperacaoLinhaFechamento["RECLASSIFICAR"] = "RECLASSIFICAR";
    TipoOperacaoLinhaFechamento["REMOVER"] = "REMOVER";
    /** Desfaz o REMOVER de um mês anterior — "trazer de volta" é um fato novo, não um UPDATE. */
    TipoOperacaoLinhaFechamento["RESTAURAR"] = "RESTAURAR";
    TipoOperacaoLinhaFechamento["LANCAR_AVULSO"] = "LANCAR_AVULSO";
    TipoOperacaoLinhaFechamento["ANOTAR"] = "ANOTAR";
})(TipoOperacaoLinhaFechamento || (TipoOperacaoLinhaFechamento = {}));
export var CustoProjetoEscopo;
(function (CustoProjetoEscopo) {
    CustoProjetoEscopo["JOB"] = "JOB";
    CustoProjetoEscopo["PLANILHA"] = "PLANILHA";
    CustoProjetoEscopo["ITEM"] = "ITEM";
})(CustoProjetoEscopo || (CustoProjetoEscopo = {}));
export var CustoProjetoTipo;
(function (CustoProjetoTipo) {
    CustoProjetoTipo["DESPESA_EXTRAORDINARIA"] = "DESPESA_EXTRAORDINARIA";
    CustoProjetoTipo["COMISSAO"] = "COMISSAO";
})(CustoProjetoTipo || (CustoProjetoTipo = {}));
export var CustoProjetoCategoria;
(function (CustoProjetoCategoria) {
    /** Custo assumido para ganhar/defender a conta (desconto embutido, brinde, ação pontual). */
    CustoProjetoCategoria["INVESTIMENTO_COMERCIAL"] = "INVESTIMENTO_COMERCIAL";
    /** Retrabalho ou gasto gerado por falha interna da Hub. */
    CustoProjetoCategoria["ERRO_OPERACIONAL"] = "ERRO_OPERACIONAL";
    /** Custo para cobrir atraso, defeito ou não entrega de um fornecedor. */
    CustoProjetoCategoria["REPOSICAO_FORNECEDOR"] = "REPOSICAO_FORNECEDOR";
    /** Algo que a Hub decide pagar pelo cliente para reduzir risco/atrito na relação. */
    CustoProjetoCategoria["CORTESIA_CLIENTE"] = "CORTESIA_CLIENTE";
    /** SLA não cumprido, cancelamento ou penalidade contratual. */
    CustoProjetoCategoria["MULTA_CONTRATUAL"] = "MULTA_CONTRATUAL";
})(CustoProjetoCategoria || (CustoProjetoCategoria = {}));
export var CustoProjetoStatus;
(function (CustoProjetoStatus) {
    CustoProjetoStatus["RASCUNHO"] = "RASCUNHO";
    CustoProjetoStatus["EM_APROVACAO"] = "EM_APROVACAO";
    CustoProjetoStatus["APROVADO"] = "APROVADO";
    CustoProjetoStatus["REPROVADO"] = "REPROVADO";
    CustoProjetoStatus["CANCELADO"] = "CANCELADO";
})(CustoProjetoStatus || (CustoProjetoStatus = {}));
export var CustoProjetoEventoTipo;
(function (CustoProjetoEventoTipo) {
    CustoProjetoEventoTipo["LANCAMENTO"] = "LANCAMENTO";
    CustoProjetoEventoTipo["ESTORNO"] = "ESTORNO";
    /**
    * Correção do valor antes da consolidação — só em `RASCUNHO`/`REPROVADO`. Carrega
    * o **delta com sinal** (positivo sobe, negativo desce) até o novo valor. Diferente
    * do `ESTORNO` (que só abate custo já aprovado), preserva o rastro da edição.
    */
    CustoProjetoEventoTipo["REAJUSTE"] = "REAJUSTE";
    CustoProjetoEventoTipo["ENVIADO_APROVACAO"] = "ENVIADO_APROVACAO";
    CustoProjetoEventoTipo["APROVADO"] = "APROVADO";
    CustoProjetoEventoTipo["REPROVADO"] = "REPROVADO";
    CustoProjetoEventoTipo["CANCELADO"] = "CANCELADO";
    /** Aprovação abortada (o fluxo foi cancelado): submissão retirada, volta ao rascunho. */
    CustoProjetoEventoTipo["APROVACAO_CANCELADA"] = "APROVACAO_CANCELADA";
})(CustoProjetoEventoTipo || (CustoProjetoEventoTipo = {}));
export var Dashboard;
(function (Dashboard) {
    // Atendimento
    Dashboard["EXECUTIVO_ATENDIMENTO"] = "executivo-atendimento";
    Dashboard["CREDITOS_ATENDIMENTO"] = "creditos-atendimento";
    Dashboard["PLANILHAS_ATENDIMENTO"] = "planilhas-atendimento";
    Dashboard["SNAPSHOTS_ATENDIMENTO"] = "snapshots-atendimento";
    // Pré Produção
    Dashboard["JOBS_PRE_PRODUCAO"] = "jobs-pre-producao";
    Dashboard["PLANILHAS_PRE_PRODUCAO"] = "planilhas-pre-producao";
    Dashboard["EQUIPE_PRE_PRODUCAO"] = "equipe-pre-producao";
    // Compras
    Dashboard["COMPRAS"] = "compras";
    Dashboard["EQUIPE_COMPRAS"] = "equipe-compras";
    // Financeiro
    Dashboard["ADIANTAMENTOS_FINANCEIRO"] = "adiantamentos-financeiro";
    // Antigos (Looker Studio)
    Dashboard["EXECUTIVO"] = "executivo";
    Dashboard["DIRETORIA_COMPRAS"] = "diretoria-compras";
    Dashboard["DIRETORIA_ATENDIMENTO"] = "diretoria-atendimento";
    Dashboard["DIRETORIA_PRE_PRODUCAO"] = "diretoria-pre-producao";
})(Dashboard || (Dashboard = {}));
export var Empresa;
(function (Empresa) {
    Empresa["HUB_PROMO"] = "HUB_PROMO";
    Empresa["HUB_MARKETING"] = "HUB_MARKETING";
})(Empresa || (Empresa = {}));
export var EscopoDeSquad;
(function (EscopoDeSquad) {
    EscopoDeSquad["DO_SQUAD"] = "DO_SQUAD";
    EscopoDeSquad["FORA_DO_SQUAD"] = "FORA_DO_SQUAD";
})(EscopoDeSquad || (EscopoDeSquad = {}));
export var TipoEtapaDeAprovacao;
(function (TipoEtapaDeAprovacao) {
    TipoEtapaDeAprovacao["PRE_PRODUCAO"] = "PRE_PRODUCAO";
    TipoEtapaDeAprovacao["DIRETORIA"] = "DIRETORIA";
    TipoEtapaDeAprovacao["CLIENTE"] = "CLIENTE";
})(TipoEtapaDeAprovacao || (TipoEtapaDeAprovacao = {}));
export var EtapaNome;
(function (EtapaNome) {
    EtapaNome["CLIENTE"] = "CLIENTE";
    EtapaNome["PRE_PRODUCAO"] = "PRE_PRODUCAO";
    EtapaNome["HEAD_COMPRAS"] = "HEAD_COMPRAS";
    EtapaNome["CFO"] = "CFO";
    EtapaNome["CTO"] = "CTO";
    EtapaNome["CEO"] = "CEO";
    EtapaNome["CBO"] = "CBO";
    EtapaNome["DESAPROVADOR"] = "DESAPROVADOR";
    EtapaNome["ADMINISTRADOR"] = "ADMINISTRADOR";
    EtapaNome["DIRETOR_PRODUCAO"] = "DIRETOR_PRODUCAO";
})(EtapaNome || (EtapaNome = {}));
export var FaturamentoStatus;
(function (FaturamentoStatus) {
    FaturamentoStatus["PENDENTE"] = "PENDENTE";
    FaturamentoStatus["FATURANDO"] = "FATURANDO";
    FaturamentoStatus["FATURADO"] = "FATURADO";
    FaturamentoStatus["PAGO"] = "PAGO";
    FaturamentoStatus["REPROVADO"] = "REPROVADO";
    FaturamentoStatus["DESFEITO"] = "DESFEITO";
    FaturamentoStatus["CANCELADO"] = "CANCELADO";
})(FaturamentoStatus || (FaturamentoStatus = {}));
export var FaturamentoHistoricoAcao;
(function (FaturamentoHistoricoAcao) {
    FaturamentoHistoricoAcao["CRIACAO"] = "CRIACAO";
    FaturamentoHistoricoAcao["FATURADO"] = "FATURADO";
    FaturamentoHistoricoAcao["PAGO"] = "PAGO";
    FaturamentoHistoricoAcao["REPROVADO"] = "REPROVADO";
    FaturamentoHistoricoAcao["CANCELADO"] = "CANCELADO";
    FaturamentoHistoricoAcao["DESFEITO"] = "DESFEITO";
})(FaturamentoHistoricoAcao || (FaturamentoHistoricoAcao = {}));
export var FaturamentoTipoItem;
(function (FaturamentoTipoItem) {
    FaturamentoTipoItem["PLANILHA"] = "PLANILHA";
})(FaturamentoTipoItem || (FaturamentoTipoItem = {}));
export var FaturamentoTipo;
(function (FaturamentoTipo) {
    FaturamentoTipo["INTERNO"] = "INTERNO";
    FaturamentoTipo["REPASSE"] = "REPASSE";
    FaturamentoTipo["INTEGRAL"] = "INTEGRAL";
})(FaturamentoTipo || (FaturamentoTipo = {}));
export var FaturamentoOrigem;
(function (FaturamentoOrigem) {
    FaturamentoOrigem["PLANILHA"] = "PLANILHA";
})(FaturamentoOrigem || (FaturamentoOrigem = {}));
export var FaturavelTipo;
(function (FaturavelTipo) {
    FaturavelTipo["ATENDIMENTO"] = "ATENDIMENTO";
    FaturavelTipo["ATIVACAO"] = "ATIVACAO";
    FaturavelTipo["BRINDES"] = "BRINDES";
    FaturavelTipo["DIVERSOS"] = "DIVERSOS";
    FaturavelTipo["EVENTO_FISICO"] = "EVENTO_FISICO";
    FaturavelTipo["FEE"] = "FEE";
    FaturavelTipo["INCENTIVO"] = "INCENTIVO";
    FaturavelTipo["MATERIAIS"] = "MATERIAIS";
    FaturavelTipo["MPDV"] = "MPDV";
    FaturavelTipo["PROMOCAO"] = "PROMOCAO";
    FaturavelTipo["TRIANGULACAO"] = "TRIANGULACAO";
})(FaturavelTipo || (FaturavelTipo = {}));
export var FilaAprovacaoStatus;
(function (FilaAprovacaoStatus) {
    FilaAprovacaoStatus["EM_ANDAMENTO"] = "EM_ANDAMENTO";
    FilaAprovacaoStatus["APROVADA"] = "APROVADA";
    FilaAprovacaoStatus["REPROVADA"] = "REPROVADA";
    FilaAprovacaoStatus["CANCELADA"] = "CANCELADA";
})(FilaAprovacaoStatus || (FilaAprovacaoStatus = {}));
export var FonteFinanceiraNome;
(function (FonteFinanceiraNome) {
    FonteFinanceiraNome["ATENDIMENTO"] = "ATENDIMENTO";
    FonteFinanceiraNome["PRE_PRODUCAO"] = "PRE_PRODUCAO";
    FonteFinanceiraNome["COMPRAS"] = "COMPRAS";
    FonteFinanceiraNome["EXECUCAO"] = "EXECUCAO";
    FonteFinanceiraNome["AP_UPDATED"] = "AP_UPDATED";
    FonteFinanceiraNome["MANUAL"] = "MANUAL";
    FonteFinanceiraNome["CONCILIACAO"] = "CONCILIACAO";
    FonteFinanceiraNome["FATURAMENTO"] = "FATURAMENTO";
    FonteFinanceiraNome["FATURAMENTO_PROPAGACAO"] = "FATURAMENTO_PROPAGACAO";
})(FonteFinanceiraNome || (FonteFinanceiraNome = {}));
export var ItemClienteOrigem;
(function (ItemClienteOrigem) {
    ItemClienteOrigem["PLANILHA"] = "PLANILHA";
})(ItemClienteOrigem || (ItemClienteOrigem = {}));
export var JobArquivoPapel;
(function (JobArquivoPapel) {
    JobArquivoPapel["BRIEFING"] = "BRIEFING";
    JobArquivoPapel["PAPER"] = "PAPER";
    JobArquivoPapel["ESTUDO_VERBA"] = "ESTUDO_VERBA";
    JobArquivoPapel["PROJETO_EXECUTIVO"] = "PROJETO_EXECUTIVO";
    JobArquivoPapel["PROJETO_FINAL"] = "PROJETO_FINAL";
})(JobArquivoPapel || (JobArquivoPapel = {}));
export var JobLogEvento;
(function (JobLogEvento) {
    JobLogEvento["CRIADO"] = "CRIADO";
    JobLogEvento["REATIVADO"] = "REATIVADO";
    JobLogEvento["INATIVADO"] = "INATIVADO";
    JobLogEvento["CLIENTE_ALTERADO"] = "CLIENTE_ALTERADO";
    JobLogEvento["ALTERADO"] = "ALTERADO";
    JobLogEvento["BRIEFING_ANEXADO"] = "BRIEFING_ANEXADO";
    JobLogEvento["PAPER_ANEXADO"] = "PAPER_ANEXADO";
    JobLogEvento["ESTUDO_VERBA_ANEXADO"] = "ESTUDO_VERBA_ANEXADO";
    JobLogEvento["PROJETO_EXECUTIVO_ANEXADO"] = "PROJETO_EXECUTIVO_ANEXADO";
    JobLogEvento["PROJETO_FINAL_ANEXADO"] = "PROJETO_FINAL_ANEXADO";
    JobLogEvento["PLANILHA_ADICIONADA"] = "PLANILHA_ADICIONADA";
    JobLogEvento["DATA_EVENTO_CONFIRMACAO_DERRUBADA"] = "DATA_EVENTO_CONFIRMACAO_DERRUBADA";
})(JobLogEvento || (JobLogEvento = {}));
export var JobPlanejamentoStatus;
(function (JobPlanejamentoStatus) {
    JobPlanejamentoStatus["EM_EXECUCAO"] = "EM_EXECUCAO";
    JobPlanejamentoStatus["COM_CRIACAO"] = "COM_CRIACAO";
    JobPlanejamentoStatus["CONCLUIDO"] = "CONCLUIDO";
    JobPlanejamentoStatus["NAO_APLICAVEL"] = "NAO_APLICAVEL";
    JobPlanejamentoStatus["STAND_BY"] = "STAND_BY";
    JobPlanejamentoStatus["AGUARDANDO_BRIEF_CLIENTE"] = "AGUARDANDO_BRIEF_CLIENTE";
    JobPlanejamentoStatus["AGUARDANDO_ESTUDO_VERBA"] = "AGUARDANDO_ESTUDO_VERBA";
    JobPlanejamentoStatus["AGUARDANDO_PASSAGEM_INTERNA"] = "AGUARDANDO_PASSAGEM_INTERNA";
})(JobPlanejamentoStatus || (JobPlanejamentoStatus = {}));
export var JobTipo;
(function (JobTipo) {
    JobTipo["ATIVACAO"] = "ATIVACAO";
    JobTipo["BRINDES"] = "BRINDES";
    JobTipo["DIVERSOS"] = "DIVERSOS";
    JobTipo["EVENTO_FISICO"] = "EVENTO_FISICO";
    JobTipo["FEE"] = "FEE";
    JobTipo["INCENTIVO"] = "INCENTIVO";
    JobTipo["MATERIAIS"] = "MATERIAIS";
    JobTipo["MPDV"] = "MPDV";
    JobTipo["PROMOCAO"] = "PROMOCAO";
    JobTipo["TRIANGULACAO"] = "TRIANGULACAO";
})(JobTipo || (JobTipo = {}));
export var JobStatus;
(function (JobStatus) {
    JobStatus["EM_ANDAMENTO"] = "EM_ANDAMENTO";
    JobStatus["EM_BRIEFING"] = "EM_BRIEFING";
    JobStatus["EM_PROJETO"] = "EM_PROJETO";
    JobStatus["ENCERRADO"] = "ENCERRADO";
})(JobStatus || (JobStatus = {}));
export var JobPerfil;
(function (JobPerfil) {
    JobPerfil["ESTRATEGICO"] = "ESTRATEGICO";
    JobPerfil["TATICO"] = "TATICO";
    JobPerfil["OPERACIONAL"] = "OPERACIONAL";
    JobPerfil["INSTITUCIONAL"] = "INSTITUCIONAL";
})(JobPerfil || (JobPerfil = {}));
export var ModoAprovacao;
(function (ModoAprovacao) {
    ModoAprovacao["SEQUENCIAL"] = "SEQUENCIAL";
    ModoAprovacao["POR_ETAPAS"] = "POR_ETAPAS";
})(ModoAprovacao || (ModoAprovacao = {}));
export var ProcessoAprovacao;
(function (ProcessoAprovacao) {
    ProcessoAprovacao["CUSTO_PROJETO"] = "CUSTO_PROJETO";
    ProcessoAprovacao["CUSTO_BUDGET"] = "CUSTO_BUDGET";
})(ProcessoAprovacao || (ProcessoAprovacao = {}));
export var FluxoAprovacaoStatus;
(function (FluxoAprovacaoStatus) {
    FluxoAprovacaoStatus["EM_ANDAMENTO"] = "EM_ANDAMENTO";
    FluxoAprovacaoStatus["APROVADO"] = "APROVADO";
    FluxoAprovacaoStatus["REPROVADO"] = "REPROVADO";
    FluxoAprovacaoStatus["CANCELADO"] = "CANCELADO";
})(FluxoAprovacaoStatus || (FluxoAprovacaoStatus = {}));
export var EtapaAprovacaoFluxoStatus;
(function (EtapaAprovacaoFluxoStatus) {
    EtapaAprovacaoFluxoStatus["PENDENTE"] = "PENDENTE";
    EtapaAprovacaoFluxoStatus["APROVADA"] = "APROVADA";
    EtapaAprovacaoFluxoStatus["REPROVADA"] = "REPROVADA";
    /**
    * Etapa pulada automaticamente pelo motor porque **todos** os seus aprovadores
    * estavam ausentes ou inativos no momento em que ela se tornou corrente. Não conta
    * como aprovação — a trilha registra `ETAPA_PULADA` com o motivo.
    */
    EtapaAprovacaoFluxoStatus["PULADA"] = "PULADA";
})(EtapaAprovacaoFluxoStatus || (EtapaAprovacaoFluxoStatus = {}));
export var DecisaoAprovacao;
(function (DecisaoAprovacao) {
    DecisaoAprovacao["PENDENTE"] = "PENDENTE";
    DecisaoAprovacao["APROVADO"] = "APROVADO";
    DecisaoAprovacao["REPROVADO"] = "REPROVADO";
})(DecisaoAprovacao || (DecisaoAprovacao = {}));
export var ModoEtapaAprovacao;
(function (ModoEtapaAprovacao) {
    ModoEtapaAprovacao["TODOS"] = "TODOS";
    ModoEtapaAprovacao["QUALQUER"] = "QUALQUER";
    ModoEtapaAprovacao["UM_POR_CARGO"] = "UM_POR_CARGO";
})(ModoEtapaAprovacao || (ModoEtapaAprovacao = {}));
export var FluxoAprovacaoEventoTipo;
(function (FluxoAprovacaoEventoTipo) {
    /** O fluxo foi aberto (quem solicitou/abriu) — primeira linha da trilha. */
    FluxoAprovacaoEventoTipo["FLUXO_ABERTO"] = "FLUXO_ABERTO";
    FluxoAprovacaoEventoTipo["ETAPA_ENTROU"] = "ETAPA_ENTROU";
    /** Etapa pulada por indisponibilidade (todos ausentes/inativos) — carrega o motivo. */
    FluxoAprovacaoEventoTipo["ETAPA_PULADA"] = "ETAPA_PULADA";
    /** Decisão individual de aprovação numa etapa (quem aprovou, com etapa e comentário). */
    FluxoAprovacaoEventoTipo["DECISAO_APROVADA"] = "DECISAO_APROVADA";
    /** Decisão individual de reprovação numa etapa (quem reprovou, com etapa e motivo). */
    FluxoAprovacaoEventoTipo["DECISAO_REPROVADA"] = "DECISAO_REPROVADA";
    FluxoAprovacaoEventoTipo["APROVADO"] = "APROVADO";
    FluxoAprovacaoEventoTipo["REPROVADO"] = "REPROVADO";
    FluxoAprovacaoEventoTipo["CANCELADO"] = "CANCELADO";
})(FluxoAprovacaoEventoTipo || (FluxoAprovacaoEventoTipo = {}));
export var NivelAlocacaoMembroEnum;
(function (NivelAlocacaoMembroEnum) {
    NivelAlocacaoMembroEnum["JOB"] = "JOB";
    NivelAlocacaoMembroEnum["PLANILHA"] = "PLANILHA";
})(NivelAlocacaoMembroEnum || (NivelAlocacaoMembroEnum = {}));
export var NotificacaoCanal;
(function (NotificacaoCanal) {
    NotificacaoCanal["EMAIL"] = "EMAIL";
    NotificacaoCanal["WHATSAPP"] = "WHATSAPP";
    NotificacaoCanal["SMS"] = "SMS";
    /** Chat interno (Hub Inbox) — entrega no chat + web push no PWA. Ver docs/inbox-integracao.md. */
    NotificacaoCanal["INBOX"] = "INBOX";
})(NotificacaoCanal || (NotificacaoCanal = {}));
export var NotificacaoTemplate;
(function (NotificacaoTemplate) {
    // Sistema
    NotificacaoTemplate["BOAS_VINDAS"] = "boas-vindas";
    // Versões
    NotificacaoTemplate["APROVACAO_PENDENTE"] = "sua-vez-aprovar";
    NotificacaoTemplate["ETAPA_PULADA_APROVACAO"] = "etapa-pulada-aprovacao";
    NotificacaoTemplate["INICIO_APROVACAO_VERSAO"] = "inicio-aprovacao-versao";
    NotificacaoTemplate["VERSAO_APROVADA_INTERNAMENTE"] = "versao-aprovada-internamente";
    NotificacaoTemplate["VERSAO_APROVADA"] = "versao-aprovada";
    NotificacaoTemplate["VERSAO_APROVADA_COMPRADORES"] = "versao-aprovada-compradores";
    NotificacaoTemplate["VERSAO_APROVADA_TI"] = "versao-aprovada-ti";
    NotificacaoTemplate["VERSAO_APROVADA_PARCIALMENTE"] = "versao-aprovada-parcialmente";
    NotificacaoTemplate["VERSAO_APROVADA_PARCIALMENTE_COMPRADORES"] = "versao-aprovada-parcialmente-compradores";
    NotificacaoTemplate["VERSAO_REPROVADA"] = "versao-reprovada";
    NotificacaoTemplate["VERSAO_DESAPROVADA"] = "versao-desaprovada";
    NotificacaoTemplate["REQUISITAR_MODERACAO_VERSAO"] = "requisitar-moderacao-versao";
    // Compras
    NotificacaoTemplate["COMPRA_CRIADA"] = "compra-criada";
    NotificacaoTemplate["PRODUTOR_FINANCEIRO_ALTERADO"] = "produtor-financeiro-alterado";
    NotificacaoTemplate["PRODUTOR_GRAFICO_ALTERADO"] = "produtor-grafico-alterado";
    NotificacaoTemplate["GANHO_REAL_ALTERADO"] = "ganho-real-alterado";
    // APs
    NotificacaoTemplate["PLANILHA_VINCULADA_AP"] = "planilha-vinculada-ap";
    // Faturamentos
    NotificacaoTemplate["CRIACAO_PEDIDO_FATURAMENTO"] = "criacao-pedido-faturamento";
    NotificacaoTemplate["CANCELAR_PEDIDO_FATURAMENTO"] = "cancelar-pedido-faturamento";
    NotificacaoTemplate["CONCLUIR_PEDIDO_FATURAMENTO"] = "concluir-pedido-faturamento";
    NotificacaoTemplate["REPROVAR_PEDIDO_FATURAMENTO"] = "reprovar-pedido-faturamento";
    NotificacaoTemplate["DESFAZER_PEDIDO_FATURAMENTO"] = "desfazer-pedido-faturamento";
    NotificacaoTemplate["FATURAMENTOS_PAGOS"] = "faturamentos-pagos";
    // Motor de aprovação genérico
    NotificacaoTemplate["APROVACAO_ETAPA_PENDENTE"] = "aprovacao-etapa-pendente";
    NotificacaoTemplate["APROVACAO_FINALIZADA"] = "aprovacao-finalizada";
    // Custo de projeto — mensagens dedicadas por subtipo (substituem o genérico p/ custo)
    NotificacaoTemplate["DESPESA_APROVACAO_ETAPA_PENDENTE"] = "despesa-aprovacao-etapa-pendente";
    NotificacaoTemplate["DESPESA_APROVACAO_FINALIZADA"] = "despesa-aprovacao-finalizada";
    NotificacaoTemplate["COMISSAO_APROVACAO_ETAPA_PENDENTE"] = "comissao-aprovacao-etapa-pendente";
    NotificacaoTemplate["COMISSAO_APROVACAO_FINALIZADA"] = "comissao-aprovacao-finalizada";
    // Planilha
    NotificacaoTemplate["JUSTIFICATIVA_SIMILARIDADE"] = "justificativa-similaridade";
    NotificacaoTemplate["SIMILARIDADE_DETECTADA"] = "similaridade-detectada";
    // Tarefas
    NotificacaoTemplate["NOVA_MENSAGEM_TAREFA"] = "nova-mensagem-tarefa";
    NotificacaoTemplate["SOLICITACAO_AP_PLANILHA"] = "solicitacao-ap-planilha";
    NotificacaoTemplate["QUESTIONAR_VERSAO"] = "questionar-versao";
    NotificacaoTemplate["CONCLUIDO_QUESTIONAR_VERSAO"] = "concluido-questionar-versao";
    NotificacaoTemplate["SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO"] = "solicitar-ajuste-planilha-atendimento";
    NotificacaoTemplate["CONCLUIDO_SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO"] = "concluido-solicitar-ajuste-planilha-atendimento";
    NotificacaoTemplate["QUESTIONAR_ARQUIVO_APROVACAO"] = "questionar-arquivo-aprovacao";
    NotificacaoTemplate["CONCLUIDO_QUESTIONAR_ARQUIVO_APROVACAO"] = "concluido-questionar-arquivo-aprovacao";
    NotificacaoTemplate["QUESTIONAR_JOB"] = "questionar-job";
    NotificacaoTemplate["CONCLUIDO_QUESTIONAR_JOB"] = "concluido-questionar-job";
    NotificacaoTemplate["QUESTIONAR_BRIEFING"] = "questionar-briefing";
    NotificacaoTemplate["CONCLUIDO_QUESTIONAR_BRIEFING"] = "concluido-questionar-briefing";
    NotificacaoTemplate["QUESTIONAR_PAPER"] = "questionar-paper";
    NotificacaoTemplate["CONCLUIDO_QUESTIONAR_PAPER"] = "concluido-questionar-paper";
    NotificacaoTemplate["CRIAR_CLIENTE_TAREFA"] = "criar-cliente-tarefa";
    NotificacaoTemplate["OBSERVADOR_ADICIONADO_TAREFA"] = "observador-adicionado-tarefa";
    NotificacaoTemplate["OBSERVADOR_REMOVIDO_TAREFA"] = "observador-removido-tarefa";
    NotificacaoTemplate["SOLICITAR_ORCAMENTO_PRE_PRODUCAO"] = "solicitar-orcamento-pre-producao";
    NotificacaoTemplate["SOLICITAR_AJUSTE_AP"] = "solicitar-ajuste-ap";
    NotificacaoTemplate["CONCLUIDO_SOLICITAR_AJUSTE_AP"] = "concluido-solicitar-ajuste-ap";
    NotificacaoTemplate["COBRAR_APROVACAO_AP"] = "cobrar-aprovacao-ap";
    NotificacaoTemplate["CONCLUIDO_COBRAR_APROVACAO_AP"] = "concluido-cobrar-aprovacao-ap";
    NotificacaoTemplate["SOLICITAR_DESFATURAMENTO"] = "solicitar-desfaturamento";
    NotificacaoTemplate["PEDIDO_ANIVERSARIO_CONTATOS"] = "pedido-aniversario-contatos";
    NotificacaoTemplate["PEDIDO_GIFT_AVISO_RESPONSAVEL"] = "pedido-gift-aviso-responsavel";
    NotificacaoTemplate["DATA_PRAZO_ALTERADO_TAREFA"] = "data-prazo-alterado-tarefa";
    // Grupo de Crédito
    NotificacaoTemplate["GRUPO_CREDITO_CRIADO"] = "grupo-credito-criado";
    NotificacaoTemplate["CREDITO_TRANSFERIDO"] = "credito-transferido";
    // Pessoa
    NotificacaoTemplate["ADICIONADO_COMO_SUBSTITUTO"] = "adicionado-como-substituto";
})(NotificacaoTemplate || (NotificacaoTemplate = {}));
export var OcasiaoBrinde;
(function (OcasiaoBrinde) {
    OcasiaoBrinde["ANIVERSARIO"] = "ANIVERSARIO";
    OcasiaoBrinde["DIA_DAS_MAES"] = "DIA_DAS_MAES";
    OcasiaoBrinde["DIA_DOS_PAIS"] = "DIA_DOS_PAIS";
    OcasiaoBrinde["NATAL"] = "NATAL";
    OcasiaoBrinde["OUTRA"] = "OUTRA";
})(OcasiaoBrinde || (OcasiaoBrinde = {}));
export var PedidoBrindeStatus;
(function (PedidoBrindeStatus) {
    PedidoBrindeStatus["PENDENTE"] = "PENDENTE";
    PedidoBrindeStatus["EM_ANDAMENTO"] = "EM_ANDAMENTO";
    PedidoBrindeStatus["FECHADO"] = "FECHADO";
})(PedidoBrindeStatus || (PedidoBrindeStatus = {}));
export var ModoDoBrinde;
(function (ModoDoBrinde) {
    ModoDoBrinde["IGUAL_PARA_TODOS"] = "IGUAL_PARA_TODOS";
    ModoDoBrinde["PERSONALIZADO"] = "PERSONALIZADO";
})(ModoDoBrinde || (ModoDoBrinde = {}));
export var PedidoBrindeItemStatus;
(function (PedidoBrindeItemStatus) {
    PedidoBrindeItemStatus["PENDENTE"] = "PENDENTE";
    PedidoBrindeItemStatus["CONCLUIDO"] = "CONCLUIDO";
    PedidoBrindeItemStatus["NAO_CONCLUIDO"] = "NAO_CONCLUIDO";
})(PedidoBrindeItemStatus || (PedidoBrindeItemStatus = {}));
export var PedidoBrindeSituacao;
(function (PedidoBrindeSituacao) {
    PedidoBrindeSituacao["PRONTO"] = "PRONTO";
    PedidoBrindeSituacao["AVISO"] = "AVISO";
    PedidoBrindeSituacao["FORA"] = "FORA";
})(PedidoBrindeSituacao || (PedidoBrindeSituacao = {}));
export var PedidoBrindeMotivo;
(function (PedidoBrindeMotivo) {
    PedidoBrindeMotivo["CONTATO_NAO_ENCONTRADO"] = "CONTATO_NAO_ENCONTRADO";
    PedidoBrindeMotivo["CONTATO_FORA_DE_USO"] = "CONTATO_FORA_DE_USO";
    PedidoBrindeMotivo["NAO_CONTATAR"] = "NAO_CONTATAR";
    PedidoBrindeMotivo["SEM_ANIVERSARIO"] = "SEM_ANIVERSARIO";
    PedidoBrindeMotivo["SEM_DATA_MARCADA"] = "SEM_DATA_MARCADA";
    PedidoBrindeMotivo["JA_TEM_PEDIDO_ABERTO"] = "JA_TEM_PEDIDO_ABERTO";
    PedidoBrindeMotivo["ENDERECO_AUSENTE"] = "ENDERECO_AUSENTE";
    PedidoBrindeMotivo["ENDERECO_DESATUALIZADO"] = "ENDERECO_DESATUALIZADO";
})(PedidoBrindeMotivo || (PedidoBrindeMotivo = {}));
export var EnvioIgnoradoMotivo;
(function (EnvioIgnoradoMotivo) {
    EnvioIgnoradoMotivo["INDISPONIVEL"] = "INDISPONIVEL";
    EnvioIgnoradoMotivo["JA_ENCERRADA"] = "JA_ENCERRADA";
})(EnvioIgnoradoMotivo || (EnvioIgnoradoMotivo = {}));
export var PermissaoEnum;
(function (PermissaoEnum) {
    PermissaoEnum["ADMIN"] = "ADMIN";
    PermissaoEnum["OPERADOR"] = "OPERADOR";
    PermissaoEnum["JOB_CREATE"] = "JOB_CREATE";
    PermissaoEnum["JOB_UPDATE"] = "JOB_UPDATE";
    PermissaoEnum["JOB_DELETE"] = "JOB_DELETE";
    PermissaoEnum["JOB_FIND_ALL"] = "JOB_FIND_ALL";
    PermissaoEnum["PLANILHA_VIEW_FINANCE"] = "PLANILHA_VIEW_FINANCE";
    PermissaoEnum["JOB_FEELING_UPDATE"] = "JOB_FEELING_UPDATE";
    PermissaoEnum["AP_FIND_ALL"] = "AP_FIND_ALL";
    PermissaoEnum["AP_CREATE"] = "AP_CREATE";
    PermissaoEnum["AP_UPDATE"] = "AP_UPDATE";
    PermissaoEnum["PLANILHA_CREATE"] = "PLANILHA_CREATE";
    PermissaoEnum["PLANILHA_UPDATE"] = "PLANILHA_UPDATE";
    PermissaoEnum["PLANILHA_DELETE"] = "PLANILHA_DELETE";
    PermissaoEnum["PLANILHA_INATIVAR"] = "PLANILHA_INATIVAR";
    PermissaoEnum["PLANILHA_REATIVAR"] = "PLANILHA_REATIVAR";
    PermissaoEnum["PLANILHA_RECALCULAR"] = "PLANILHA_RECALCULAR";
    PermissaoEnum["JOB_PLANEJAMENTO_CREATE"] = "JOB_PLANEJAMENTO_CREATE";
    PermissaoEnum["JOB_PLANEJAMENTO_FIND_ALL"] = "JOB_PLANEJAMENTO_FIND_ALL";
    PermissaoEnum["JOB_PLANEJAMENTO_DELETE"] = "JOB_PLANEJAMENTO_DELETE";
    PermissaoEnum["JOB_PLANEJAMENTO_UPDATE"] = "JOB_PLANEJAMENTO_UPDATE";
    PermissaoEnum["JOB_TECNOLOGIA_FIND_ALL"] = "JOB_TECNOLOGIA_FIND_ALL";
    PermissaoEnum["JOB_TECNOLOGIA_CREATE"] = "JOB_TECNOLOGIA_CREATE";
    PermissaoEnum["JOB_TECNOLOGIA_UPDATE"] = "JOB_TECNOLOGIA_UPDATE";
    PermissaoEnum["JOB_CRIACAO_FIND_ALL"] = "JOB_CRIACAO_FIND_ALL";
    PermissaoEnum["JOB_CRIACAO_UPDATE"] = "JOB_CRIACAO_UPDATE";
    PermissaoEnum["PLANILHA_PRODUCAO_GRAFICA_FIND_ALL"] = "PLANILHA_PRODUCAO_GRAFICA_FIND_ALL";
    PermissaoEnum["PLANILHA_PRODUCAO_GRAFICA_CREATE"] = "PLANILHA_PRODUCAO_GRAFICA_CREATE";
    PermissaoEnum["PLANILHA_PRODUCAO_GRAFICA_UPDATE"] = "PLANILHA_PRODUCAO_GRAFICA_UPDATE";
    PermissaoEnum["PLANILHA_FIND_ALL"] = "PLANILHA_FIND_ALL";
    PermissaoEnum["PLANILHA_ATENDIMENTO_CREATE"] = "PLANILHA_ATENDIMENTO_CREATE";
    PermissaoEnum["PLANILHA_ATENDIMENTO_UPDATE"] = "PLANILHA_ATENDIMENTO_UPDATE";
    PermissaoEnum["PLANILHA_ATENDIMENTO_DELETE"] = "PLANILHA_ATENDIMENTO_DELETE";
    PermissaoEnum["PLANILHA_ATENDIMENTO_FIND_ALL"] = "PLANILHA_ATENDIMENTO_FIND_ALL";
    PermissaoEnum["PLANILHA_PRE_CREATE"] = "PLANILHA_PRE_CREATE";
    PermissaoEnum["PLANILHA_PRE_DELETE"] = "PLANILHA_PRE_DELETE";
    PermissaoEnum["PLANILHA_PRE_UPDATE"] = "PLANILHA_PRE_UPDATE";
    PermissaoEnum["PLANILHA_PRE_FIND_ALL"] = "PLANILHA_PRE_FIND_ALL";
    PermissaoEnum["PLANILHA_PRE_ALOCAR_PRE_PRODUTOR"] = "PLANILHA_PRE_ALOCAR_PRE_PRODUTOR";
    PermissaoEnum["PLANILHA_COMPRAS_CREATE"] = "PLANILHA_COMPRAS_CREATE";
    PermissaoEnum["PLANILHA_COMPRAS_UPDATE"] = "PLANILHA_COMPRAS_UPDATE";
    PermissaoEnum["PLANILHA_COMPRAS_DELETE"] = "PLANILHA_COMPRAS_DELETE";
    PermissaoEnum["PLANILHA_COMPRAS_FIND_ALL"] = "PLANILHA_COMPRAS_FIND_ALL";
    PermissaoEnum["ANO_COMPETENCIA_PLANILHA"] = "ANO_COMPETENCIA_PLANILHA";
    PermissaoEnum["VERSAO_CREATE"] = "VERSAO_CREATE";
    PermissaoEnum["VERSAO_UPDATE"] = "VERSAO_UPDATE";
    PermissaoEnum["VERSAO_DESAPROVAR_PRE_CLIENTE"] = "VERSAO_DESAPROVAR_PRE_CLIENTE";
    PermissaoEnum["VERSAO_DESAPROVAR_PRE_INTERNO"] = "VERSAO_DESAPROVAR_PRE_INTERNO";
    PermissaoEnum["VERSAO_DESAPROVAR_COMPRAS"] = "VERSAO_DESAPROVAR_COMPRAS";
    PermissaoEnum["VERSAO_DESAPROVAR_ATENDIMENTO"] = "VERSAO_DESAPROVAR_ATENDIMENTO";
    PermissaoEnum["VERSAO_RESOLVER_APROVACAO_PARCIAL"] = "VERSAO_RESOLVER_APROVACAO_PARCIAL";
    PermissaoEnum["VERSAO_FIND_ALL"] = "VERSAO_FIND_ALL";
    PermissaoEnum["VERSAO_ENVIAR_PROPOSTA_CLIENTE"] = "VERSAO_ENVIAR_PROPOSTA_CLIENTE";
    PermissaoEnum["VERSAO_APROVAR_ETAPA_CLIENTE"] = "VERSAO_APROVAR_ETAPA_CLIENTE";
    PermissaoEnum["CREDITO_FIND_ALL"] = "CREDITO_FIND_ALL";
    PermissaoEnum["CREDITO_CREATE"] = "CREDITO_CREATE";
    PermissaoEnum["CREDITO_UPDATE"] = "CREDITO_UPDATE";
    PermissaoEnum["GRUPO_CREDITO_CREATE"] = "GRUPO_CREDITO_CREATE";
    PermissaoEnum["GRUPO_CREDITO_UPDATE"] = "GRUPO_CREDITO_UPDATE";
    PermissaoEnum["GRUPO_CREDITO_DELETE"] = "GRUPO_CREDITO_DELETE";
    PermissaoEnum["GRUPO_CREDITO_FIND_ALL"] = "GRUPO_CREDITO_FIND_ALL";
    PermissaoEnum["FATURAMENTO_ATENDIMENTO_CREATE"] = "FATURAMENTO_ATENDIMENTO_CREATE";
    PermissaoEnum["FATURAMENTO_ATENDIMENTO_UPDATE"] = "FATURAMENTO_ATENDIMENTO_UPDATE";
    PermissaoEnum["FATURAMENTO_ATENDIMENTO_FIND_ALL"] = "FATURAMENTO_ATENDIMENTO_FIND_ALL";
    PermissaoEnum["FATURAMENTO_ATENDIMENTO_CANCEL"] = "FATURAMENTO_ATENDIMENTO_CANCEL";
    PermissaoEnum["FATURAMENTO_FINANCEIRO_CREATE"] = "FATURAMENTO_FINANCEIRO_CREATE";
    PermissaoEnum["FATURAMENTO_FINANCEIRO_UPDATE"] = "FATURAMENTO_FINANCEIRO_UPDATE";
    PermissaoEnum["FATURAMENTO_FINANCEIRO_FIND_ALL"] = "FATURAMENTO_FINANCEIRO_FIND_ALL";
    // Despesa Extraordinária (Produção) — lançamento com abrangência de equipe
    PermissaoEnum["DESPESA_PROJETO_CREATE"] = "DESPESA_PROJETO_CREATE";
    PermissaoEnum["DESPESA_PROJETO_FIND_ALL"] = "DESPESA_PROJETO_FIND_ALL";
    PermissaoEnum["DESPESA_PROJETO_UPDATE"] = "DESPESA_PROJETO_UPDATE";
    PermissaoEnum["DESPESA_PROJETO_CANCELAR"] = "DESPESA_PROJETO_CANCELAR";
    // Comissão (Controladoria) — lançamento sem vínculo, visibilidade por permissão
    PermissaoEnum["COMISSAO_CREATE"] = "COMISSAO_CREATE";
    PermissaoEnum["COMISSAO_FIND_ALL"] = "COMISSAO_FIND_ALL";
    PermissaoEnum["COMISSAO_UPDATE"] = "COMISSAO_UPDATE";
    PermissaoEnum["COMISSAO_CANCELAR"] = "COMISSAO_CANCELAR";
    // Consolida a comissão direto (RASCUNHO → APROVADO), sem passar por fluxo de aprovação.
    PermissaoEnum["COMISSAO_CONSOLIDAR"] = "COMISSAO_CONSOLIDAR";
    // Motor de aprovação genérico
    // Decisão segmentada por processo (gate de menu/rota; o endpoint genérico aceita qualquer uma)
    PermissaoEnum["ROTA_APROVACAO_DESPESA_DECIDIR"] = "ROTA_APROVACAO_DESPESA_DECIDIR";
    PermissaoEnum["APROVACAO_CONFIG_MANAGE"] = "APROVACAO_CONFIG_MANAGE";
    // Custo Fixo (feature temporária — acesso restrito a C-levels)
    PermissaoEnum["ROTA_CUSTO_FIXO"] = "ROTA_CUSTO_FIXO";
    // Comunicados do Sistema (avisos globais publicados pelo admin)
    PermissaoEnum["COMUNICADO_SISTEMA_MANAGE"] = "COMUNICADO_SISTEMA_MANAGE";
    // Gestão de Custo Fixo (novo modelo — docs/gestao-custo-fixo-conceito.md)
    // Centro de custo é a espinha da governança (dono, escopo, budget): criar/editar é
    // só do ADMIN, que entra por bypass de nome — nenhum cargo recebe esta permissão.
    PermissaoEnum["CENTRO_CUSTO_MANAGE"] = "CENTRO_CUSTO_MANAGE";
    // Natureza e Elemento de Custo (o "o que é" / "o que se paga") — Financeiro/Controladoria.
    PermissaoEnum["CATALOGO_CUSTO_MANAGE"] = "CATALOGO_CUSTO_MANAGE";
    // Contrato recorrente e suas parcelas (Fase 2). CREATE/UPDATE são do operador de custo e do
    // dono do centro — cargos que ainda não existem, então nenhum papel os recebe e só o ADMIN
    // entra, por bypass de nome. Atribuir depois é acrescentar a linha no RolePermissaoMapping.
    PermissaoEnum["CUSTO_FIXO_CREATE"] = "CUSTO_FIXO_CREATE";
    PermissaoEnum["CUSTO_FIXO_UPDATE"] = "CUSTO_FIXO_UPDATE";
    PermissaoEnum["CUSTO_FIXO_FIND_ALL"] = "CUSTO_FIXO_FIND_ALL";
    // Abrangência global: atua em qualquer centro, não só onde é dono. A ausência deste gate é
    // o que transforma "operador central" em "dono de área" quando a Fase 3 ligar o escopo.
    PermissaoEnum["CUSTO_FIXO_TODOS_CENTROS"] = "CUSTO_FIXO_TODOS_CENTROS";
    // Leitura global (Fase 7.1): vê qualquer centro, não edita nenhum por este eixo — o par de
    // CUSTO_FIXO_TODOS_CENTROS na leitura. Não concedida a nenhum cargo nesta entrega.
    PermissaoEnum["CUSTO_FIXO_VER_TODOS_CENTROS"] = "CUSTO_FIXO_VER_TODOS_CENTROS";
    // Orçamento versionado (Fase 4, §14.3). MANAGE = criar/editar/enviar a revisão; a decisão
    // (aprovar/reprovar) passa pelo motor genérico (APROVACAO_DECIDIR), não por esta permissão.
    PermissaoEnum["CUSTO_BUDGET_MANAGE"] = "CUSTO_BUDGET_MANAGE";
    PermissaoEnum["CUSTO_BUDGET_FIND_ALL"] = "CUSTO_BUDGET_FIND_ALL";
    // Gate de menu/rota da fila "minha fila decide" do orçamento — a Diretoria é configurada
    // pelo Admin em ConfiguracaoAprovacao, sem cargo fixo; nenhum papel recebe por padrão.
    PermissaoEnum["ROTA_APROVACAO_BUDGET_DECIDIR"] = "ROTA_APROVACAO_BUDGET_DECIDIR";
    // Fechamento mensal (Fase 6, §3.6): fecha o período (grid) e manda pro motor de aprovação.
    // Edição das linhas do grid usa CUSTO_FIXO_UPDATE — o mesmo gate de mexer numa parcela.
    PermissaoEnum["FECHAMENTO_FECHAR"] = "FECHAMENTO_FECHAR";
    // Gate de menu/rota da fila "minha fila decide" do fechamento — mesmo padrão do budget.
    PermissaoEnum["CONCILIACAO_APS_RENTABILIDADE_UPDATE"] = "CONCILIACAO_APS_RENTABILIDADE_UPDATE";
    PermissaoEnum["CONCILIACAO_APS_RENTABILIDADE_FIND_ALL"] = "CONCILIACAO_APS_RENTABILIDADE_FIND_ALL";
    PermissaoEnum["PESSOA_CREATE"] = "PESSOA_CREATE";
    PermissaoEnum["PESSOA_DELETE"] = "PESSOA_DELETE";
    PermissaoEnum["PESSOA_ADD_ROLE"] = "PESSOA_ADD_ROLE";
    PermissaoEnum["PESSOA_REMOVE_ROLE"] = "PESSOA_REMOVE_ROLE";
    PermissaoEnum["PESSOA_FIND_ALL"] = "PESSOA_FIND_ALL";
    PermissaoEnum["ROLE_ADD_PERMISSAO"] = "ROLE_ADD_PERMISSAO";
    PermissaoEnum["ROLE_REMOVE_PERMISSAO"] = "ROLE_REMOVE_PERMISSAO";
    PermissaoEnum["ROLE_FIND_ALL"] = "ROLE_FIND_ALL";
    PermissaoEnum["PERMISSAO_FIND_ALL"] = "PERMISSAO_FIND_ALL";
    PermissaoEnum["APROVADOR_PRE_PRODUCAO"] = "APROVADOR_PRE_PRODUCAO";
    PermissaoEnum["APROVADOR_COMPRAS"] = "APROVADOR_COMPRAS";
    PermissaoEnum["TAREFA_SOLICITAR_AP"] = "TAREFA_SOLICITAR_AP";
    PermissaoEnum["TAREFA_SOLICITAR_AJUSTE_AP"] = "TAREFA_SOLICITAR_AJUSTE_AP";
    PermissaoEnum["TAREFA_COBRAR_APROVACAO_AP"] = "TAREFA_COBRAR_APROVACAO_AP";
    PermissaoEnum["TAREFA_SOLICITAR_DESFATURAMENTO"] = "TAREFA_SOLICITAR_DESFATURAMENTO";
    PermissaoEnum["TAREFA_PEDIR_BRINDE_CONTATO"] = "TAREFA_PEDIR_BRINDE_CONTATO";
    PermissaoEnum["TAREFA_SOLICITAR_AJUSTE_ATENDIMENTO"] = "TAREFA_SOLICITAR_AJUSTE_ATENDIMENTO";
    PermissaoEnum["TAREFA_SOLICITAR_ORCAMENTO_PRE_PRODUCAO"] = "TAREFA_SOLICITAR_ORCAMENTO_PRE_PRODUCAO";
    PermissaoEnum["CRIAR_TAREFA_GENERICA"] = "CRIAR_TAREFA_GENERICA";
    PermissaoEnum["DOWNLOAD_PLANILHA_INTERNA"] = "DOWNLOAD_PLANILHA_INTERNA";
    PermissaoEnum["DOWNLOAD_PLANILHA_INTERNA_COMPRAS"] = "DOWNLOAD_PLANILHA_INTERNA_COMPRAS";
    PermissaoEnum["DOWNLOAD_PLANILHA_CLIENTE"] = "DOWNLOAD_PLANILHA_CLIENTE";
    PermissaoEnum["DOWNLOAD_PLANILHA_CLIENTE_ATENDIMENTO"] = "DOWNLOAD_PLANILHA_CLIENTE_ATENDIMENTO";
    PermissaoEnum["DOWNLOAD_PLANILHA_APROVACAO"] = "DOWNLOAD_PLANILHA_APROVACAO";
    PermissaoEnum["DOWNLOAD_PLANILHA_AP"] = "DOWNLOAD_PLANILHA_AP";
    PermissaoEnum["DOWNLOAD_BRIEFING_JOB"] = "DOWNLOAD_BRIEFING_JOB";
    PermissaoEnum["DOWNLOAD_PAPER_JOB"] = "DOWNLOAD_PAPER_JOB";
    PermissaoEnum["DOWNLOAD_ESTUDO_VERBA_JOB"] = "DOWNLOAD_ESTUDO_VERBA_JOB";
    PermissaoEnum["DOWNLOAD_PROJETO_EXECUTIVO_JOB"] = "DOWNLOAD_PROJETO_EXECUTIVO_JOB";
    PermissaoEnum["DOWNLOAD_PROJETO_FINAL_JOB"] = "DOWNLOAD_PROJETO_FINAL_JOB";
    PermissaoEnum["DOWNLOAD_ORDEM_COMPRA"] = "DOWNLOAD_ORDEM_COMPRA";
    PermissaoEnum["DOWNLOAD_NOTA_FISCAL"] = "DOWNLOAD_NOTA_FISCAL";
    PermissaoEnum["DOWNLOAD_COMPROVANTE_ENTREGA_FATURAMENTO"] = "DOWNLOAD_COMPROVANTE_ENTREGA_FATURAMENTO";
    PermissaoEnum["DOWNLOAD_EVIDENCIA_BRINDE"] = "DOWNLOAD_EVIDENCIA_BRINDE";
    PermissaoEnum["DOWNLOAD_APRESENTACAO_JOB_PLANEJAMENTO"] = "DOWNLOAD_APRESENTACAO_JOB_PLANEJAMENTO";
    PermissaoEnum["MENU_ADMIN"] = "MENU_ADMIN";
    PermissaoEnum["MENU_ATENDIMENTO"] = "MENU_ATENDIMENTO";
    PermissaoEnum["MENU_PLANEJAMENTO"] = "MENU_PLANEJAMENTO";
    PermissaoEnum["MENU_PRE_PRODUCAO"] = "MENU_PRE_PRODUCAO";
    PermissaoEnum["MENU_COMPRAS"] = "MENU_COMPRAS";
    PermissaoEnum["MENU_PRODUCAO"] = "MENU_PRODUCAO";
    PermissaoEnum["MENU_CONTROLADORIA"] = "MENU_CONTROLADORIA";
    PermissaoEnum["MENU_APROVACOES"] = "MENU_APROVACOES";
    PermissaoEnum["MENU_DASHBOARD"] = "MENU_DASHBOARD";
    PermissaoEnum["MENU_PRODUCAO_FINANCEIRO"] = "MENU_PRODUCAO_FINANCEIRO";
    PermissaoEnum["MENU_FINANCEIRO"] = "MENU_FINANCEIRO";
    PermissaoEnum["MENU_TECNOLOGIA"] = "MENU_TECNOLOGIA";
    PermissaoEnum["MENU_PRODUCAO_GRAFICA"] = "MENU_PRODUCAO_GRAFICA";
    PermissaoEnum["MENU_CRIACAO"] = "MENU_CRIACAO";
    PermissaoEnum["MENU_CUSTO_FIXO"] = "MENU_CUSTO_FIXO";
    PermissaoEnum["MENU_FACILITIES"] = "MENU_FACILITIES";
    PermissaoEnum["RELATORIO_PLANILHA_ATENDIMENTO"] = "RELATORIO_PLANILHA_ATENDIMENTO";
    PermissaoEnum["ROTA_JOB"] = "ROTA_JOB";
    PermissaoEnum["ROTA_JOB_AGENDA"] = "ROTA_JOB_AGENDA";
    PermissaoEnum["ROTA_PRE_PRODUCAO_AGENDA"] = "ROTA_PRE_PRODUCAO_AGENDA";
    PermissaoEnum["ROTA_TECNOLOGIA_AGENDA"] = "ROTA_TECNOLOGIA_AGENDA";
    PermissaoEnum["ROTA_PLANEJAMENTO_AGENDA"] = "ROTA_PLANEJAMENTO_AGENDA";
    PermissaoEnum["ROTA_PLANEJAMENTO"] = "ROTA_PLANEJAMENTO";
    PermissaoEnum["ROTA_PLANILHAS_ATENDIMENTO"] = "ROTA_PLANILHAS_ATENDIMENTO";
    PermissaoEnum["ROTA_PLANILHAS_PRE_PRODUCAO"] = "ROTA_PLANILHAS_PRE_PRODUCAO";
    PermissaoEnum["ROTA_PLANILHAS_COMPRAS"] = "ROTA_PLANILHAS_COMPRAS";
    PermissaoEnum["ROTA_PLANILHAS_PRODUCAO"] = "ROTA_PLANILHAS_PRODUCAO";
    PermissaoEnum["ROTA_PLANILHAS_PRODUCAO_GRAFICA"] = "ROTA_PLANILHAS_PRODUCAO_GRAFICA";
    PermissaoEnum["ROTA_PLANILHAS_APROVACAO"] = "ROTA_PLANILHAS_APROVACAO";
    PermissaoEnum["ROTA_USUARIOS"] = "ROTA_USUARIOS";
    PermissaoEnum["ROTA_PERMISSOES"] = "ROTA_PERMISSOES";
    PermissaoEnum["ROTA_TAREFAS_ADMIN"] = "ROTA_TAREFAS_ADMIN";
    PermissaoEnum["ROTA_CLIENTES_ADMIN"] = "ROTA_CLIENTES_ADMIN";
    PermissaoEnum["ROTA_SQUADS_ADMIN"] = "ROTA_SQUADS_ADMIN";
    PermissaoEnum["ROTA_ARQUIVOS_ADMIN"] = "ROTA_ARQUIVOS_ADMIN";
    PermissaoEnum["ROTA_DASHBOARD_EXECUTIVO_ATENDIMENTO"] = "ROTA_DASHBOARD_EXECUTIVO_ATENDIMENTO";
    PermissaoEnum["ROTA_DASHBOARD_ATENDIMENTO_CREDITOS"] = "ROTA_DASHBOARD_ATENDIMENTO_CREDITOS";
    PermissaoEnum["ROTA_DASHBOARD_ATENDIMENTO_PLANILHAS"] = "ROTA_DASHBOARD_ATENDIMENTO_PLANILHAS";
    PermissaoEnum["ROTA_DASHBOARD_ATENDIMENTO_SNAPSHOTS"] = "ROTA_DASHBOARD_ATENDIMENTO_SNAPSHOTS";
    PermissaoEnum["ROTA_DASHBOARD_PRE_PRODUCAO_JOBS"] = "ROTA_DASHBOARD_PRE_PRODUCAO_JOBS";
    PermissaoEnum["ROTA_DASHBOARD_PRE_PRODUCAO_PLANILHAS"] = "ROTA_DASHBOARD_PRE_PRODUCAO_PLANILHAS";
    PermissaoEnum["ROTA_DASHBOARD_PRE_PRODUCAO_EQUIPE"] = "ROTA_DASHBOARD_PRE_PRODUCAO_EQUIPE";
    PermissaoEnum["ROTA_DASHBOARD_COMPRAS"] = "ROTA_DASHBOARD_COMPRAS";
    PermissaoEnum["ROTA_DASHBOARD_EQUIPE_COMPRAS"] = "ROTA_DASHBOARD_EQUIPE_COMPRAS";
    PermissaoEnum["ROTA_DASHBOARD_ADIANTAMENTOS_FINANCEIRO"] = "ROTA_DASHBOARD_ADIANTAMENTOS_FINANCEIRO";
    PermissaoEnum["ROTA_DASHBOARD_EXECUTIVO"] = "ROTA_DASHBOARD_EXECUTIVO";
    PermissaoEnum["ROTA_DASHBOARD_DIRETORIA_ATENDIMENTO"] = "ROTA_DASHBOARD_DIRETORIA_ATENDIMENTO";
    PermissaoEnum["ROTA_DASHBOARD_DIRETORIA_PRE_PRODUCAO"] = "ROTA_DASHBOARD_DIRETORIA_PRE";
    PermissaoEnum["ROTA_DASHBOARD_DIRETORIA_COMPRAS"] = "ROTA_DASHBOARD_DIRETORIA_COMPRAS";
    PermissaoEnum["ROTA_PLANILHAS_PRODUCAO_FINANCEIRO_APS"] = "ROTA_PLANILHAS_PRODUCAO_FINANCEIRO_APS";
    PermissaoEnum["ROTA_VERSOES_PRE_PRODUCAO"] = "ROTA_VERSOES_PRE_PRODUCAO";
    PermissaoEnum["ROTA_FATURAMENTOS_ATENDIMENTO"] = "ROTA_FATURAMENTOS_ATENDIMENTO";
    PermissaoEnum["ROTA_CREDITAVEIS_ATENDIMENTO"] = "ROTA_CREDITAVEIS_ATENDIMENTO";
    PermissaoEnum["ROTA_FATURAMENTOS_FINANCEIRO"] = "ROTA_FATURAMENTOS_FINANCEIRO";
    PermissaoEnum["ROTA_CONCILIACOES_PRODUCAO_FINANCEIRO"] = "ROTA_CONCILIACOES_PRODUCAO_FINANCEIRO";
    PermissaoEnum["ROTA_PROCESSAMENTO_IA_ADMIN"] = "ROTA_PROCESSAMENTO_IA_ADMIN";
    PermissaoEnum["ROTA_TECNOLOGIA_JOBS"] = "ROTA_TECNOLOGIA_JOBS";
    PermissaoEnum["ROTA_CRIACAO_JOBS"] = "ROTA_CRIACAO_JOBS";
    // Atendimento — listagem de clientes (somente leitura, leva ao Painel 360).
    // Atribuída aos cargos com ROTA_JOB (usuários de atendimento).
    PermissaoEnum["ROTA_ATENDIMENTO_CLIENTES"] = "ROTA_ATENDIMENTO_CLIENTES";
    // Produtividade por área — docs/produtividade-por-area.md §5.3-1.
    // Uma por área; fase 1 só atribui a de Atendimento (§12.4). As demais
    // (PRE_PRODUCAO, COMPRAS, PRODUCAO_FINANCEIRA) entram junto da respectiva área.
    PermissaoEnum["ROTA_PRODUTIVIDADE_ATENDIMENTO"] = "ROTA_PRODUTIVIDADE_ATENDIMENTO";
    // Base de Contatos — docs/base-contatos-implementacao.md §8. Rota da área piloto (Atendimento) + permissões de dados.
    PermissaoEnum["ROTA_ATENDIMENTO_CONTATOS"] = "ROTA_ATENDIMENTO_CONTATOS";
    PermissaoEnum["ROTA_PRE_PRODUCAO_CONTATOS"] = "ROTA_PRE_PRODUCAO_CONTATOS";
    PermissaoEnum["ROTA_COMPRAS_CONTATOS"] = "ROTA_COMPRAS_CONTATOS";
    PermissaoEnum["ROTA_FACILITIES_CONTATOS"] = "ROTA_FACILITIES_CONTATOS";
    PermissaoEnum["ROTA_FACILITIES_ENVIOS"] = "ROTA_FACILITIES_ENVIOS";
    PermissaoEnum["CONTATO_FIND_ALL"] = "CONTATO_FIND_ALL";
    PermissaoEnum["CONTATO_CREATE"] = "CONTATO_CREATE";
    PermissaoEnum["CONTATO_UPDATE"] = "CONTATO_UPDATE";
    PermissaoEnum["CONTATO_DADOS_PESSOAIS_VER"] = "CONTATO_DADOS_PESSOAIS_VER";
    PermissaoEnum["CONTATO_ENVIOS_EXPORTAR"] = "CONTATO_ENVIOS_EXPORTAR";
    PermissaoEnum["TAREFA_ENVIOS_CONCLUIR"] = "TAREFA_ENVIOS_CONCLUIR";
    PermissaoEnum["CONTATO_ANONIMIZAR"] = "CONTATO_ANONIMIZAR";
    PermissaoEnum["CONTATO_MESCLAR"] = "CONTATO_MESCLAR";
    PermissaoEnum["CONTATO_VER_TODOS"] = "CONTATO_VER_TODOS";
    // Uma dupla por tipo de contato (ContatoTipoMapping): ver, e criar/editar (gerir).
    PermissaoEnum["CONTATO_TIPO_CLIENTE_VER"] = "CONTATO_TIPO_CLIENTE_VER";
    PermissaoEnum["CONTATO_TIPO_CLIENTE_GERIR"] = "CONTATO_TIPO_CLIENTE_GERIR";
    PermissaoEnum["CONTATO_TIPO_FORNECEDOR_VER"] = "CONTATO_TIPO_FORNECEDOR_VER";
    PermissaoEnum["CONTATO_TIPO_FORNECEDOR_GERIR"] = "CONTATO_TIPO_FORNECEDOR_GERIR";
    PermissaoEnum["CONTATO_TIPO_PARCEIRO_VER"] = "CONTATO_TIPO_PARCEIRO_VER";
    PermissaoEnum["CONTATO_TIPO_PARCEIRO_GERIR"] = "CONTATO_TIPO_PARCEIRO_GERIR";
})(PermissaoEnum || (PermissaoEnum = {}));
export var PlanilhaCompraTipo;
(function (PlanilhaCompraTipo) {
    PlanilhaCompraTipo["NOVA"] = "NOVA";
    PlanilhaCompraTipo["ATRIBUIDA"] = "ATRIBUIDA";
    PlanilhaCompraTipo["SEM_OPORTUNIDADE"] = "SEM_OPORTUNIDADE";
})(PlanilhaCompraTipo || (PlanilhaCompraTipo = {}));
export var PlanilhaLogEvento;
(function (PlanilhaLogEvento) {
    PlanilhaLogEvento["ABERTA"] = "ABERTA";
    PlanilhaLogEvento["INATIVADA"] = "INATIVADA";
    PlanilhaLogEvento["REATIVADA"] = "REATIVADA";
    PlanilhaLogEvento["ENVIADA_APROVACAO"] = "ENVIADA_APROVACAO";
    PlanilhaLogEvento["ENVIADA_APROVACAO_QUENTE"] = "ENVIADA_APROVACAO_QUENTE";
    PlanilhaLogEvento["APROVADA"] = "APROVADA";
    PlanilhaLogEvento["REPROVADA"] = "REPROVADA";
    PlanilhaLogEvento["REABERTA_DE_REPROVACAO"] = "REABERTA_DE_REPROVACAO";
    PlanilhaLogEvento["APROVACAO_PARCIAL_INCREMENTADA"] = "APROVACAO_PARCIAL_INCREMENTADA";
    PlanilhaLogEvento["APROVACAO_PARCIAL_CONCLUIDA"] = "APROVACAO_PARCIAL_CONCLUIDA";
    PlanilhaLogEvento["FATURANDO"] = "FATURANDO";
    PlanilhaLogEvento["FATURADA"] = "FATURADA";
    PlanilhaLogEvento["VALOR_ATUALIZADO"] = "VALOR_ATUALIZADO";
    PlanilhaLogEvento["CREDITO_GERADO"] = "CREDITO_GERADO";
    PlanilhaLogEvento["CREDITO_ESTORNADO"] = "CREDITO_ESTORNADO";
    PlanilhaLogEvento["ALTERADO"] = "ALTERADO";
    PlanilhaLogEvento["VERSAO_CRIADA"] = "VERSAO_CRIADA";
    PlanilhaLogEvento["VERSAO_APROVADA"] = "VERSAO_APROVADA";
    PlanilhaLogEvento["VERSAO_REPROVADA"] = "VERSAO_REPROVADA";
    PlanilhaLogEvento["VERSAO_CANCELADA"] = "VERSAO_CANCELADA";
    PlanilhaLogEvento["VERSAO_DESAPROVADA"] = "VERSAO_DESAPROVADA";
    PlanilhaLogEvento["VERSAO_APROVADA_INTERNAMENTE"] = "VERSAO_APROVADA_INTERNAMENTE";
})(PlanilhaLogEvento || (PlanilhaLogEvento = {}));
export var PlanilhaOrdemJob;
(function (PlanilhaOrdemJob) {
    PlanilhaOrdemJob["PRINCIPAL"] = "PRINCIPAL";
    PlanilhaOrdemJob["JOB_NOVO"] = "JOB_NOVO";
    PlanilhaOrdemJob["COMPLEMENTAR"] = "COMPLEMENTAR";
})(PlanilhaOrdemJob || (PlanilhaOrdemJob = {}));
export var OrigemBudgetPlanilha;
(function (OrigemBudgetPlanilha) {
    OrigemBudgetPlanilha["DEFINIDO_PELO_CLIENTE"] = "DEFINIDO_PELO_CLIENTE";
    OrigemBudgetPlanilha["ESTIMATIVA_INICIAL"] = "ESTIMATIVA_INICIAL";
})(OrigemBudgetPlanilha || (OrigemBudgetPlanilha = {}));
export var PlanilhaStatus;
(function (PlanilhaStatus) {
    PlanilhaStatus["PENDENTE"] = "PENDENTE";
    PlanilhaStatus["APROVADO"] = "APROVADO";
    PlanilhaStatus["REPROVADO"] = "REPROVADO";
})(PlanilhaStatus || (PlanilhaStatus = {}));
export var StatusProcessamentoIA;
(function (StatusProcessamentoIA) {
    StatusProcessamentoIA["PENDENTE"] = "PENDENTE";
    StatusProcessamentoIA["CONCLUIDO"] = "CONCLUIDO";
    StatusProcessamentoIA["FALHA"] = "FALHA";
})(StatusProcessamentoIA || (StatusProcessamentoIA = {}));
export var TipoProcessamentoIA;
(function (TipoProcessamentoIA) {
    TipoProcessamentoIA["ANALISE_BRIEFING"] = "ANALISE_BRIEFING_JOB";
    TipoProcessamentoIA["VERSAO_ITENS"] = "VERSAO_ITENS";
    TipoProcessamentoIA["PREDICAO_RENTABILIDADE"] = "PREDICAO_RENTABILIDADE";
    TipoProcessamentoIA["AREA_DETECTION"] = "AREA_DETECTION";
})(TipoProcessamentoIA || (TipoProcessamentoIA = {}));
export var EntidadeReferenciaProcessamentoIA;
(function (EntidadeReferenciaProcessamentoIA) {
    EntidadeReferenciaProcessamentoIA["JOB"] = "JOB";
    EntidadeReferenciaProcessamentoIA["VERSAO"] = "VERSAO";
})(EntidadeReferenciaProcessamentoIA || (EntidadeReferenciaProcessamentoIA = {}));
export var BlocoProdutividadeId;
(function (BlocoProdutividadeId) {
    // §7.0 — compartilhados entre áreas
    BlocoProdutividadeId["TAREFAS_CONCLUIDAS"] = "TAREFAS_CONCLUIDAS";
    BlocoProdutividadeId["TAREFAS_POR_TIPO"] = "TAREFAS_POR_TIPO";
    BlocoProdutividadeId["ATIVIDADE_POR_DIA"] = "ATIVIDADE_POR_DIA";
    // §7.1 — Atendimento
    BlocoProdutividadeId["PLANILHAS_ABERTAS"] = "PLANILHAS_ABERTAS";
    BlocoProdutividadeId["PLANILHAS_ENVIADAS_APROVACAO"] = "PLANILHAS_ENVIADAS_APROVACAO";
    BlocoProdutividadeId["JOBS_CRIADOS"] = "JOBS_CRIADOS";
})(BlocoProdutividadeId || (BlocoProdutividadeId = {}));
export var EscopoProdutividadeEnum;
(function (EscopoProdutividadeEnum) {
    EscopoProdutividadeEnum[EscopoProdutividadeEnum["PROPRIA"] = 1] = "PROPRIA";
    EscopoProdutividadeEnum[EscopoProdutividadeEnum["EQUIPE"] = 2] = "EQUIPE";
    EscopoProdutividadeEnum[EscopoProdutividadeEnum["AREA"] = 3] = "AREA";
    EscopoProdutividadeEnum[EscopoProdutividadeEnum["TODAS"] = 4] = "TODAS";
})(EscopoProdutividadeEnum || (EscopoProdutividadeEnum = {}));
export var PubSubTopic;
(function (PubSubTopic) {
    PubSubTopic["DATA_ORQUESTRATOR_PROCESS_AI"] = "workflow-to-data-orchestrator";
})(PubSubTopic || (PubSubTopic = {}));
export var RecursoSistema;
(function (RecursoSistema) {
    RecursoSistema["PLANILHA_ATENDIMENTO"] = "PLANILHA_ATENDIMENTO";
    RecursoSistema["PLANILHA_COMPRAS"] = "PLANILHA_COMPRAS";
    RecursoSistema["PLANILHA_PRE_PRODUCAO"] = "PLANILHA_PRE_PRODUCAO";
    RecursoSistema["NOVA_AP"] = "NOVA_AP";
    RecursoSistema["AP"] = "AP";
    RecursoSistema["JOB"] = "JOB";
    RecursoSistema["GERENCIAR_CLIENTES"] = "GERENCIAR_CLIENTES";
    RecursoSistema["FATURAMENTO_ATENDIMENTO"] = "FATURAMENTO_ATENDIMENTO";
    RecursoSistema["FATURAMENTO_FINANCEIRO"] = "FATURAMENTO_FINANCEIRO";
    RecursoSistema["CONTATO_FACILITIES"] = "CONTATO_FACILITIES";
    RecursoSistema["PEDIDO_BRINDE_FACILITIES"] = "PEDIDO_BRINDE_FACILITIES";
})(RecursoSistema || (RecursoSistema = {}));
export var ResolucaoAprovacaoParcial;
(function (ResolucaoAprovacaoParcial) {
    ResolucaoAprovacaoParcial["INCREMENTAR"] = "INCREMENTAR";
    ResolucaoAprovacaoParcial["CONCLUIR"] = "CONCLUIR";
})(ResolucaoAprovacaoParcial || (ResolucaoAprovacaoParcial = {}));
export var RoleNome;
(function (RoleNome) {
    RoleNome["ADMIN"] = "ADMIN";
    RoleNome["OPERADOR"] = "OPERADOR";
    RoleNome["CEO"] = "CEO";
    RoleNome["CTO"] = "CTO";
    RoleNome["CFO"] = "CFO";
    RoleNome["CBO"] = "CBO";
    RoleNome["DIRETOR_DE_NEGOCIOS"] = "DIRETOR_DE_NEGOCIOS";
    RoleNome["GERENTE_DE_ATENDIMENTO"] = "GERENTE_DE_ATENDIMENTO";
    RoleNome["COORDENADOR_DE_ATENDIMENTO"] = "COORDENADOR_DE_ATENDIMENTO";
    RoleNome["ASSISTENTE_DE_ATENDIMENTO"] = "ASSISTENTE_DE_ATENDIMENTO";
    RoleNome["DIRETOR_DE_PROJETOS"] = "DIRETOR_DE_PROJETOS";
    RoleNome["ATENDIMENTO"] = "ATENDIMENTO";
    RoleNome["ESTAGIARIO_DE_ATENDIMENTO"] = "ESTAGIARIO_DE_ATENDIMENTO";
    RoleNome["USER"] = "USER";
    RoleNome["HEAD_PRE"] = "HEAD_PRE";
    RoleNome["HEAD_COMPRAS"] = "HEAD_COMPRAS";
    RoleNome["PRE_PRODUTOR"] = "PRE_PRODUTOR";
    RoleNome["PRE_PRODUTOR_FREELA"] = "PRE_PRODUTOR_FREELA";
    RoleNome["DIRETOR_PRODUCAO"] = "DIRETOR_PRODUCAO";
    RoleNome["COMPRADOR"] = "COMPRADOR";
    RoleNome["PRODUTOR"] = "PRODUTOR";
    RoleNome["PRODUTOR_FINANCEIRO"] = "PRODUTOR_FINANCEIRO";
    RoleNome["GESTOR_PRODUCAO_GRAFICA"] = "GESTOR_PRODUCAO_GRAFICA";
    RoleNome["PRODUTOR_GRAFICO"] = "PRODUTOR_GRAFICO";
    RoleNome["FINANCEIRO"] = "FINANCEIRO";
    RoleNome["ASSISTENTE_FINANCEIRO"] = "ASSISTENTE_FINANCEIRO";
    RoleNome["AUDITOR"] = "AUDITOR";
    // Controladoria
    RoleNome["CONTROLADOR"] = "CONTROLADOR";
    RoleNome["CSO"] = "CSO";
    RoleNome["HEAD_PLANEJAMENTO"] = "HEAD_PLANEJAMENTO";
    RoleNome["PLANNER"] = "PLANNER";
    RoleNome["GESTOR_TI"] = "GESTOR_TI";
    RoleNome["ANALISTA_TI"] = "ANALISTA_TI";
    // Criação
    RoleNome["HEAD_CRIACAO"] = "HEAD_CRIACAO";
    RoleNome["REDATOR"] = "REDATOR";
    RoleNome["DIRETOR_DE_ARTE"] = "DIRETOR_DE_ARTE";
    RoleNome["ARTE_FINALISTA"] = "ARTE_FINALISTA";
    RoleNome["ARTISTA_3D"] = "ARTISTA_3D";
    // Administrativo (módulo Facilities): organiza o interno e despacha para clientes
    RoleNome["GESTORA_ADMINISTRATIVA"] = "GESTORA_ADMINISTRATIVA";
    // Auxiliar da gestora: mesmas permissões dela, por ora
    RoleNome["ADMINISTRATIVO"] = "ADMINISTRATIVO";
})(RoleNome || (RoleNome = {}));
export var StatusEnvioNotificacao;
(function (StatusEnvioNotificacao) {
    /** Saiu de fato pelo provedor (e-mail aceito pelo SMTP / mensagem postada na API). */
    StatusEnvioNotificacao["ENVIADA"] = "ENVIADA";
    /** Não enviada por decisão de negócio: sem telefone, template não implementado, etc. */
    StatusEnvioNotificacao["IGNORADA"] = "IGNORADA";
    /** Tentou enviar e falhou: erro de config, rede ou resposta de erro do provedor. */
    StatusEnvioNotificacao["FALHA"] = "FALHA";
})(StatusEnvioNotificacao || (StatusEnvioNotificacao = {}));
export var ConclusaoTipo;
(function (ConclusaoTipo) {
    /** Validação/dúvida/sugestão → só marca concluída. */
    ConclusaoTipo["NENHUMA"] = "NENHUMA";
    /** Link para uma página do WF (comportamento atual via `acao`). */
    ConclusaoTipo["CTA"] = "CTA";
    /** Formulário inline que, ao ser enviado, conclui a tarefa. */
    ConclusaoTipo["FORMULARIO"] = "FORMULARIO";
})(ConclusaoTipo || (ConclusaoTipo = {}));
export var DesfaturamentoTipo;
(function (DesfaturamentoTipo) {
    DesfaturamentoTipo["PROCESSUAL"] = "PROCESSUAL";
    DesfaturamentoTipo["REAL"] = "REAL";
})(DesfaturamentoTipo || (DesfaturamentoTipo = {}));
export var FormCampoTipo;
(function (FormCampoTipo) {
    FormCampoTipo["ARQUIVO"] = "ARQUIVO";
    FormCampoTipo["TEXTO"] = "TEXTO";
    FormCampoTipo["TEXTO_LONGO"] = "TEXTO_LONGO";
    FormCampoTipo["NUMERO"] = "NUMERO";
    FormCampoTipo["DATA"] = "DATA";
    FormCampoTipo["BOOLEANO"] = "BOOLEANO";
    FormCampoTipo["SELECT"] = "SELECT";
    /** Ponteiro p/ entidade do sistema (ex.: selecionar uma Pessoa). */
    FormCampoTipo["REFERENCIA"] = "REFERENCIA";
})(FormCampoTipo || (FormCampoTipo = {}));
export var MensagemTipoAutor;
(function (MensagemTipoAutor) {
    MensagemTipoAutor["CRIADOR"] = "CRIADOR";
    MensagemTipoAutor["ATRIBUIDO"] = "ATRIBUIDO";
    MensagemTipoAutor["ADMIN"] = "ADMIN";
    MensagemTipoAutor["OBSERVADOR"] = "OBSERVADOR";
    MensagemTipoAutor["SISTEMA"] = "SISTEMA";
})(MensagemTipoAutor || (MensagemTipoAutor = {}));
export var NivelSituacaoTarefa;
(function (NivelSituacaoTarefa) {
    NivelSituacaoTarefa["NENHUM"] = "NENHUM";
    NivelSituacaoTarefa["AVISO"] = "AVISO";
    NivelSituacaoTarefa["INSISTENCIA"] = "INSISTENCIA";
    NivelSituacaoTarefa["RESTRICAO"] = "RESTRICAO";
})(NivelSituacaoTarefa || (NivelSituacaoTarefa = {}));
export var TarefaLogEvento;
(function (TarefaLogEvento) {
    TarefaLogEvento["CRIADA"] = "CRIADA";
    TarefaLogEvento["INICIADA"] = "INICIADA";
    TarefaLogEvento["CONCLUIDA"] = "CONCLUIDA";
    TarefaLogEvento["CANCELADA"] = "CANCELADA";
    TarefaLogEvento["ARQUIVADA"] = "ARQUIVADA";
    TarefaLogEvento["REABERTA"] = "REABERTA";
    TarefaLogEvento["REATRIBUIDA"] = "REATRIBUIDA";
    TarefaLogEvento["PRAZO_ALTERADO"] = "PRAZO_ALTERADO";
    TarefaLogEvento["ANEXO_ADICIONADO"] = "ANEXO_ADICIONADO";
    TarefaLogEvento["ANEXO_REMOVIDO"] = "ANEXO_REMOVIDO";
    TarefaLogEvento["OBSERVADOR_ADICIONADO"] = "OBSERVADOR_ADICIONADO";
    TarefaLogEvento["OBSERVADOR_REMOVIDO"] = "OBSERVADOR_REMOVIDO";
    TarefaLogEvento["MENSAGEM_ADICIONADA"] = "MENSAGEM_ADICIONADA";
})(TarefaLogEvento || (TarefaLogEvento = {}));
export var TarefaStatus;
(function (TarefaStatus) {
    TarefaStatus["PENDENTE"] = "PENDENTE";
    TarefaStatus["EM_EXECUCAO"] = "EM_EXECUCAO";
    TarefaStatus["CONCLUIDO"] = "CONCLUIDO";
    TarefaStatus["CANCELADO"] = "CANCELADO";
    TarefaStatus["ARQUIVADO"] = "ARQUIVADO";
})(TarefaStatus || (TarefaStatus = {}));
export var TarefaTipo;
(function (TarefaTipo) {
    TarefaTipo["SOLICITAR_AP"] = "SOLICITAR_AP";
    TarefaTipo["SOLICITAR_AJUSTE_AP"] = "SOLICITAR_AJUSTE_AP";
    TarefaTipo["COBRAR_APROVACAO_AP"] = "COBRAR_APROVACAO_AP";
    TarefaTipo["QUESTIONAR_VERSAO"] = "QUESTIONAR_VERSAO";
    TarefaTipo["QUESTIONAR_ARQUIVO_APROVACAO"] = "QUESTIONAR_ARQUIVO_APROVACAO";
    TarefaTipo["QUESTIONAR_JOB"] = "QUESTIONAR_JOB";
    TarefaTipo["QUESTIONAR_BRIEFING"] = "QUESTIONAR_BRIEFING";
    TarefaTipo["QUESTIONAR_PAPER"] = "QUESTIONAR_PAPER";
    TarefaTipo["SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO"] = "SOLICITAR_AJUSTE_PLANILHA_ATENDIMENTO";
    TarefaTipo["SOLICITAR_ORCAMENTO_PRE_PRODUCAO"] = "SOLICITAR_ORCAMENTO_PRE_PRODUCAO";
    TarefaTipo["CORRIGIR_FATURAMENTO"] = "CORRIGIR_FATURAMENTO";
    TarefaTipo["SOLICITAR_DESFATURAMENTO"] = "SOLICITAR_DESFATURAMENTO";
    TarefaTipo["AP_VALOR_ABAIXO_SALDO_UTILIZADO"] = "AP_VALOR_ABAIXO_SALDO_UTILIZADO";
    TarefaTipo["CRIAR_CLIENTE"] = "CRIAR_CLIENTE";
    TarefaTipo["SOLICITAR_CRIACAO_CLIENTE"] = "SOLICITAR_CRIACAO_CLIENTE";
    TarefaTipo["GENERICA"] = "GENERICA";
    TarefaTipo["CRIAR_BRIEFING"] = "CRIAR_BRIEFING";
    TarefaTipo["CRIAR_PAPER"] = "CRIAR_PAPER";
    TarefaTipo["CRIAR_ESTUDO_VERBA"] = "CRIAR_ESTUDO_VERBA";
    // Facilities: uma tarefa por contato (base-contatos)
    TarefaTipo["PEDIDO_BRINDE"] = "PEDIDO_BRINDE";
})(TarefaTipo || (TarefaTipo = {}));
export var TarefaVisibilidade;
(function (TarefaVisibilidade) {
    TarefaVisibilidade["PUBLICA"] = "PUBLICA";
    TarefaVisibilidade["PRIVADA"] = "PRIVADA";
})(TarefaVisibilidade || (TarefaVisibilidade = {}));
export var VersaoStatus;
(function (VersaoStatus) {
    VersaoStatus["EM_REVISAO"] = "EM_REVISAO";
    VersaoStatus["EM_APROVACAO"] = "EM_APROVACAO";
    VersaoStatus["REPROVADO"] = "REPROVADO";
    VersaoStatus["CANCELADO"] = "CANCELADO";
    VersaoStatus["AGUARDANDO"] = "AGUARDANDO";
    VersaoStatus["RASCUNHO"] = "RASCUNHO";
    VersaoStatus["APROVADO_INTERNAMENTE"] = "APROVADO_INTERNAMENTE";
    VersaoStatus["ENVIADO_CLIENTE"] = "ENVIADO_CLIENTE";
    VersaoStatus["APROVADO"] = "APROVADO";
    VersaoStatus["APROVADO_PARCIALMENTE"] = "APROVADO_PARCIALMENTE";
    VersaoStatus["REPROVADO_CLIENTE"] = "REPROVADO_CLIENTE";
    VersaoStatus["DESAPROVADO"] = "DESAPROVADO";
})(VersaoStatus || (VersaoStatus = {}));
export var VersaoTipo;
(function (VersaoTipo) {
    VersaoTipo["ATENDIMENTO"] = "ATENDIMENTO";
    VersaoTipo["CLIENTE"] = "CLIENTE";
    VersaoTipo["INTERNO"] = "INTERNO";
    VersaoTipo["COMPRAS"] = "COMPRAS";
})(VersaoTipo || (VersaoTipo = {}));
